export default [
    {
        "id": "d2048579-6588-4281-898f-010d3c7d8268",
        "initial_consumption_type": "Flower",
        "value": "$100 OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "96922dce-d224-4312-babb-239bb7d40531",
        "initial_consumption_type": "Flower",
        "value": "1 Eyed Jamaican",
        "strain_type": "Hybrid"
    },
    {
        "id": "01b6e01b-012d-4db7-845f-178bb31f8c51",
        "initial_consumption_type": "Flower",
        "value": "1 Eyed Jamaican #2",
        "strain_type": "Hybrid"
    },
    {
        "id": "9810038d-0868-4cdb-b6a6-cdb96d547550",
        "initial_consumption_type": "Flower",
        "value": "1 Eyed Jamaican #3",
        "strain_type": "Hybrid"
    },
    {
        "id": "5ad9f356-47c4-492e-8b0f-6e2796b07fc7",
        "initial_consumption_type": "Flower",
        "value": "3 Kings",
        "strain_type": "Hybrid"
    },
    {
        "id": "f8f9f521-b74f-461e-83a5-e8e9e42e4d98",
        "initial_consumption_type": "Flower",
        "value": "707 Headband",
        "strain_type": "Hybrid"
    },
    {
        "id": "9561b5c2-216e-466a-aeaa-a3faefe6a049",
        "initial_consumption_type": "Flower",
        "value": "91 Chemdog",
        "strain_type": "Sativa"
    },
    {
        "id": "c7b061d5-3981-4820-a8f2-f61d02ac9968",
        "initial_consumption_type": "Flower",
        "value": "A Train",
        "strain_type": "Hybrid"
    },
    {
        "id": "437aa15e-ff8b-4152-ab12-db1dc746af3d",
        "initial_consumption_type": "Flower",
        "value": "A-10",
        "strain_type": "Indica"
    },
    {
        "id": "3b503ca4-53cc-4ecf-a1e8-f13790d7e0bb",
        "initial_consumption_type": "Flower",
        "value": "Abra Cadabra",
        "strain_type": "Hybrid"
    },
    {
        "id": "8daa9f30-1d50-4d52-ba4d-93c74f8a7327",
        "initial_consumption_type": "Flower",
        "value": "Acapulco Gold",
        "strain_type": "Hybrid"
    },
    {
        "id": "d5d48900-1930-4dce-a136-6fe121598e0a",
        "initial_consumption_type": "Flower",
        "value": "Accidental Tourist",
        "strain_type": "Hybrid"
    },
    {
        "id": "ec67b61e-c3b9-4a05-94ad-763b341f58f2",
        "initial_consumption_type": "Flower",
        "value": "ACDC",
        "strain_type": "Hybrid"
    },
    {
        "id": "39b27c51-06ac-48a8-bbe6-576b384654d1",
        "initial_consumption_type": "Flower",
        "value": "Ace of Spades",
        "strain_type": "Hybrid"
    },
    {
        "id": "71d60934-aa21-4390-895e-c33f9acebb8e",
        "initial_consumption_type": "Flower",
        "value": "Afghan Big Bud",
        "strain_type": "Hybrid"
    },
    {
        "id": "0644ac73-6783-4e75-a019-47aa1c90a1bc",
        "initial_consumption_type": "Flower",
        "value": "Afghan Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "ec92ec58-81c9-46b5-ab09-e11072850536",
        "initial_consumption_type": "Flower",
        "value": "Afghan Kush",
        "strain_type": "Indica"
    },
    {
        "id": "f18d356e-11b1-4f64-b69a-753efde61c5e",
        "initial_consumption_type": "Flower",
        "value": "Afghan Skunk",
        "strain_type": "Indica"
    },
    {
        "id": "b90e08c2-5463-49ed-9252-ce3ebfbe9626",
        "initial_consumption_type": "Flower",
        "value": "Afghani",
        "strain_type": "Indica"
    },
    {
        "id": "273e05bc-1ead-4237-8fee-6b51327f949e",
        "initial_consumption_type": "Flower",
        "value": "Afghani Bullrider",
        "strain_type": "Indica"
    },
    {
        "id": "4cf984f0-7434-4d52-b524-6a51270c2143",
        "initial_consumption_type": "Flower",
        "value": "Afghanica",
        "strain_type": "Hybrid"
    },
    {
        "id": "9ec72c5f-7b4c-4cdf-a82d-aa4c251aaa9c",
        "initial_consumption_type": "Flower",
        "value": "Afghooey",
        "strain_type": "Hybrid"
    },
    {
        "id": "12600e95-375e-4179-b8ee-3726b923ffdd",
        "initial_consumption_type": "Flower",
        "value": "Afgoo",
        "strain_type": "Indica"
    },
    {
        "id": "31d04a90-ab41-4bf2-a08e-decf92e1d680",
        "initial_consumption_type": "Flower",
        "value": "Afgooey",
        "strain_type": "Indica"
    },
    {
        "id": "e2af94a6-6e55-4324-a320-19191ce44af6",
        "initial_consumption_type": "Flower",
        "value": "Afwreck",
        "strain_type": "Hybrid"
    },
    {
        "id": "6cbce9a2-f387-4818-b849-ff5f3ec3b0c6",
        "initial_consumption_type": "Flower",
        "value": "Agent Orange",
        "strain_type": "Hybrid"
    },
    {
        "id": "70b0e530-327c-48dc-b11b-50a4b4041239",
        "initial_consumption_type": "Flower",
        "value": "AK 46",
        "strain_type": "Hybrid"
    },
    {
        "id": "1ae4333d-f109-48c0-b874-267c6b863580",
        "initial_consumption_type": "Flower",
        "value": "AK 47",
        "strain_type": "Hybrid"
    },
    {
        "id": "0e0b4eb7-610d-42bf-96d5-2e00cd2c6fd8",
        "initial_consumption_type": "Flower",
        "value": "AK 48",
        "strain_type": "Hybrid"
    },
    {
        "id": "9c197db0-533c-4bc2-be48-9bed8066b380",
        "initial_consumption_type": "Flower",
        "value": "AK47 x Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "a01689ee-85d4-4d3f-96be-a64320eff11a",
        "initial_consumption_type": "Flower",
        "value": "Alaska",
        "strain_type": "Hybrid"
    },
    {
        "id": "25b6a0f7-fb12-43df-9c33-79ced1a584cb",
        "initial_consumption_type": "Flower",
        "value": "Alaskan Thunder Bolt",
        "strain_type": "Hybrid"
    },
    {
        "id": "728f08c8-169f-46ae-b5e6-f648df46a81c",
        "initial_consumption_type": "Flower",
        "value": "Alaskan Thunder Fuck",
        "strain_type": "Sativa"
    },
    {
        "id": "a9577ac3-8e08-4442-9c25-2464e4e44947",
        "initial_consumption_type": "Flower",
        "value": "Albert Walker",
        "strain_type": "Hybrid"
    },
    {
        "id": "3e66cd0e-4d92-4cce-b5c6-7239352e1e7d",
        "initial_consumption_type": "Flower",
        "value": "Alien Blues",
        "strain_type": "Hybrid"
    },
    {
        "id": "b8c7413c-ac20-4c15-9369-e350b23279ff",
        "initial_consumption_type": "Flower",
        "value": "Alien Dawg",
        "strain_type": "Indica"
    },
    {
        "id": "28717f9a-1fad-4975-9298-a8ec1847764f",
        "initial_consumption_type": "Flower",
        "value": "Alien Kush",
        "strain_type": "Indica"
    },
    {
        "id": "6002501e-f6ce-4966-a1af-4295bad8e18f",
        "initial_consumption_type": "Flower",
        "value": "Alien OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "b65844de-4fbf-4522-a23b-464485dc520f",
        "initial_consumption_type": "Flower",
        "value": "Allen Wrench",
        "strain_type": "Sativa"
    },
    {
        "id": "7fe70389-83da-437e-a754-47c43e40f140",
        "initial_consumption_type": "Flower",
        "value": "Aloha",
        "strain_type": "Sativa"
    },
    {
        "id": "9bb19a47-275c-4796-b4fa-e5663843d3f8",
        "initial_consumption_type": "Flower",
        "value": "Alohaberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "e33972a1-38f3-4457-a629-25bfc39d6140",
        "initial_consumption_type": "Flower",
        "value": "Alpha OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "94f414f0-9c1f-4503-af4b-803c4df4074e",
        "initial_consumption_type": "Flower",
        "value": "Ambrosia",
        "strain_type": "Hybrid"
    },
    {
        "id": "b059a5f6-b965-4288-88c1-d2346a8ee50d",
        "initial_consumption_type": "Flower",
        "value": "Amethyst",
        "strain_type": "Hybrid"
    },
    {
        "id": "20a482ee-c87b-44b7-92e3-dd2211d621e7",
        "initial_consumption_type": "Flower",
        "value": "Amnesia",
        "strain_type": "Sativa"
    },
    {
        "id": "e3e21668-5de9-4218-aaa6-b00f5b05a5ae",
        "initial_consumption_type": "Flower",
        "value": "Amnesia Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "81cc7096-4ee4-448b-a5de-99dd98944e8b",
        "initial_consumption_type": "Flower",
        "value": "Andys Ak-47",
        "strain_type": "Hybrid"
    },
    {
        "id": "fabb99af-6d83-4b7c-8cf8-be269c9116fc",
        "initial_consumption_type": "Flower",
        "value": "Anesthesia",
        "strain_type": "Indica"
    },
    {
        "id": "005df796-a71f-472f-bf5a-95a633c0e11d",
        "initial_consumption_type": "Flower",
        "value": "Animal Cookies",
        "strain_type": "Hybrid"
    },
    {
        "id": "25b629df-573b-4dbb-92ea-d66090b0d405",
        "initial_consumption_type": "Flower",
        "value": "Antrax",
        "strain_type": "Indica"
    },
    {
        "id": "8911148a-8f10-4de3-96ce-c06e9c4717e0",
        "initial_consumption_type": "Flower",
        "value": "Apollo 11",
        "strain_type": "Hybrid"
    },
    {
        "id": "42aec4c3-256e-4d72-a956-e47a94fe9078",
        "initial_consumption_type": "Flower",
        "value": "Apollo 13",
        "strain_type": "Hybrid"
    },
    {
        "id": "e7284df5-d183-4bff-ba58-de0f6c15b22b",
        "initial_consumption_type": "Flower",
        "value": "Arabian Gold",
        "strain_type": "Sativa"
    },
    {
        "id": "582a2bb0-0972-4c5b-9020-b81490729ffe",
        "initial_consumption_type": "Flower",
        "value": "Arizonan Western Light Purp",
        "strain_type": "Hybrid"
    },
    {
        "id": "d0757199-ac00-4c46-98b8-1a5bfbf8dffa",
        "initial_consumption_type": "Flower",
        "value": "Arjan’s Strawberry Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "734d039d-7f4a-42a2-94e2-3aa283fb7c64",
        "initial_consumption_type": "Flower",
        "value": "Armageddon",
        "strain_type": "Hybrid"
    },
    {
        "id": "412e02b4-37a6-474a-9a42-b9a0dad1beba",
        "initial_consumption_type": "Flower",
        "value": "Asian Fantasy",
        "strain_type": "Sativa"
    },
    {
        "id": "ff311ca7-830e-4a2a-8d1e-4c105ef4124b",
        "initial_consumption_type": "Flower",
        "value": "Assassin OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "1a032bbd-a12b-4fa4-9d94-2e50a4035521",
        "initial_consumption_type": "Flower",
        "value": "Atomic Northern Lights",
        "strain_type": "Hybrid"
    },
    {
        "id": "2f1e19cb-824c-48f9-8956-d82e5bb7d719",
        "initial_consumption_type": "Flower",
        "value": "Australian Blue",
        "strain_type": "Hybrid"
    },
    {
        "id": "318ea65b-0611-4fba-b093-e731bd5626aa",
        "initial_consumption_type": "Flower",
        "value": "Avalon",
        "strain_type": "Hybrid"
    },
    {
        "id": "7d6733e6-0097-4523-81cf-7df1fc433fc9",
        "initial_consumption_type": "Flower",
        "value": "Avi-Dekel",
        "strain_type": "Hybrid"
    },
    {
        "id": "28566c10-2d1e-47c6-a69b-a9746cee4c02",
        "initial_consumption_type": "Flower",
        "value": "Banana Candy",
        "strain_type": "Indica"
    },
    {
        "id": "2c687cd7-9d69-46d1-ab43-698f0b6af97c",
        "initial_consumption_type": "Flower",
        "value": "Banana Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "9547146b-6e8a-4f35-a991-a3beee44c4c8",
        "initial_consumption_type": "Flower",
        "value": "Banana Kush",
        "strain_type": "Indica"
    },
    {
        "id": "3a1a4eab-3577-4041-a6bb-738d8ab6685a",
        "initial_consumption_type": "Flower",
        "value": "Banana OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "8d241f0f-382d-4a07-9ee8-c6999a832f5a",
        "initial_consumption_type": "Flower",
        "value": "BC Big Bud",
        "strain_type": "Hybrid"
    },
    {
        "id": "a3d7f28c-32e9-4eb7-a3ec-478ba44d77e6",
        "initial_consumption_type": "Flower",
        "value": "BC Roadkill",
        "strain_type": "Hybrid"
    },
    {
        "id": "5b0a3e6a-2637-46e6-99a7-7505960174e5",
        "initial_consumption_type": "Flower",
        "value": "BC Sweet Tooth",
        "strain_type": "Hybrid"
    },
    {
        "id": "e1a38b62-dfd2-453f-ba84-d4302fdd683e",
        "initial_consumption_type": "Flower",
        "value": "Beauty",
        "strain_type": "Sativa"
    },
    {
        "id": "bbbc3225-02f1-48a0-b9e7-69d5c0f83d7b",
        "initial_consumption_type": "Flower",
        "value": "Bedrock",
        "strain_type": "Hybrid"
    },
    {
        "id": "ab4cb891-83e1-4693-bd9b-c2b61cffa3e2",
        "initial_consumption_type": "Flower",
        "value": "Belladonna",
        "strain_type": "Hybrid"
    },
    {
        "id": "0e5ac35e-f874-427b-9184-ede30bb344c2",
        "initial_consumption_type": "Flower",
        "value": "Bentley OG",
        "strain_type": "Indica"
    },
    {
        "id": "e2bd2bf6-5318-48b7-96c6-f637d2b1dae2",
        "initial_consumption_type": "Flower",
        "value": "Berkeley",
        "strain_type": "Sativa"
    },
    {
        "id": "e8854a07-7a72-4a72-8dee-ae3a51c52cbd",
        "initial_consumption_type": "Flower",
        "value": "Berry Noir",
        "strain_type": "Indica"
    },
    {
        "id": "241c3a03-08ff-4af2-bb29-de112b9aed77",
        "initial_consumption_type": "Flower",
        "value": "Berry White",
        "strain_type": "Hybrid"
    },
    {
        "id": "f518d634-7679-4e0e-83be-2dc76babf2c0",
        "initial_consumption_type": "Flower",
        "value": "Big Bambo",
        "strain_type": "Sativa"
    },
    {
        "id": "f4cbde17-671e-4818-82bd-89c2a4a46a17",
        "initial_consumption_type": "Flower",
        "value": "Big Bang",
        "strain_type": "Indica"
    },
    {
        "id": "d637c694-9396-4455-b0bc-2745607285bf",
        "initial_consumption_type": "Flower",
        "value": "Big Bud",
        "strain_type": "Hybrid"
    },
    {
        "id": "c5133b5d-84cc-43c9-bb2c-b0a96eeb0c63",
        "initial_consumption_type": "Flower",
        "value": "Big Buddha Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "19c23036-5cd9-4027-9956-64980c64291b",
        "initial_consumption_type": "Flower",
        "value": "Big Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "1dd6cd65-9046-4132-bf0a-dc5c7c9d8c10",
        "initial_consumption_type": "Flower",
        "value": "Big Sky OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "7ef2f5a8-48bd-4ab9-a346-6847e75b9984",
        "initial_consumption_type": "Flower",
        "value": "Big Wreck",
        "strain_type": "Hybrid"
    },
    {
        "id": "e2f00884-4796-4c68-8dd2-5f605aef6d52",
        "initial_consumption_type": "Flower",
        "value": "Bio-Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "2b8efb0e-33e9-4149-ab7a-d45cc5e4a91c",
        "initial_consumption_type": "Flower",
        "value": "Bio-Jesus",
        "strain_type": "Hybrid"
    },
    {
        "id": "3a267dff-d397-4e59-b1d1-f091289f3caf",
        "initial_consumption_type": "Flower",
        "value": "Black Cherry Soda",
        "strain_type": "Indica"
    },
    {
        "id": "32ae95a2-8ef5-413f-b3bf-4ee3e6b42192",
        "initial_consumption_type": "Flower",
        "value": "Black Dahlia",
        "strain_type": "Hybrid"
    },
    {
        "id": "1409e27e-cd96-40fa-8267-e1ff286d748e",
        "initial_consumption_type": "Flower",
        "value": "Black Diamond",
        "strain_type": "Indica"
    },
    {
        "id": "e08259b7-59ba-4ffe-a296-8ce751c9f32d",
        "initial_consumption_type": "Flower",
        "value": "Black Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "eaa85490-7a71-42ed-875b-307d83e46c2b",
        "initial_consumption_type": "Flower",
        "value": "Black Domina",
        "strain_type": "Hybrid"
    },
    {
        "id": "f2a3fea8-39c6-401a-a3de-ccd2a6dadd6b",
        "initial_consumption_type": "Flower",
        "value": "Black Ice",
        "strain_type": "Hybrid"
    },
    {
        "id": "3c3425ac-8ac4-441d-9d1c-e57f534d7544",
        "initial_consumption_type": "Flower",
        "value": "Black Jack",
        "strain_type": "Hybrid"
    },
    {
        "id": "8e08f6d9-543d-4f3e-b57f-e3e68132d6a1",
        "initial_consumption_type": "Flower",
        "value": "Black Label Kush",
        "strain_type": "Indica"
    },
    {
        "id": "8019fac1-eb11-4ffb-8c09-201096792b2e",
        "initial_consumption_type": "Flower",
        "value": "Black Magic Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "faa81624-8f5f-4d09-a9c9-5e64cd8f7c98",
        "initial_consumption_type": "Flower",
        "value": "Black Mamba",
        "strain_type": "Hybrid"
    },
    {
        "id": "1a71eff4-aca8-4516-b8e0-50cad39e7772",
        "initial_consumption_type": "Flower",
        "value": "Black Rhino OG Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "bd78a054-0657-49c4-9a84-b30d7b10e853",
        "initial_consumption_type": "Flower",
        "value": "Black Tuna",
        "strain_type": "Hybrid"
    },
    {
        "id": "dcc96d37-d95b-410c-9687-39e61c310f10",
        "initial_consumption_type": "Flower",
        "value": "Black Velvet",
        "strain_type": "Hybrid"
    },
    {
        "id": "18d2c3a0-8ec5-4098-9f60-50f8644294a3",
        "initial_consumption_type": "Flower",
        "value": "Black Widow",
        "strain_type": "Hybrid"
    },
    {
        "id": "09494c01-7c92-45aa-93c8-5a1f58b4be66",
        "initial_consumption_type": "Flower",
        "value": "Blackberry",
        "strain_type": "Indica"
    },
    {
        "id": "e807aae4-a5ab-44fb-ba37-1bee6e046545",
        "initial_consumption_type": "Flower",
        "value": "Blackberry Hashplant",
        "strain_type": "Indica"
    },
    {
        "id": "f995e2bb-876e-4c15-8966-0e0910a1264f",
        "initial_consumption_type": "Flower",
        "value": "Blackberry Kush",
        "strain_type": "Indica"
    },
    {
        "id": "95f8f43e-4f6a-4630-99f4-af130d3574cc",
        "initial_consumption_type": "Flower",
        "value": "Blackwater",
        "strain_type": "Indica"
    },
    {
        "id": "4ca5813a-cd30-4ec6-9ad1-374d8440a339",
        "initial_consumption_type": "Flower",
        "value": "Blockhead",
        "strain_type": "Hybrid"
    },
    {
        "id": "ffad7e8c-791d-43b9-87cd-69c27e3458a8",
        "initial_consumption_type": "Flower",
        "value": "Blowfish",
        "strain_type": "Hybrid"
    },
    {
        "id": "abcddc29-9951-4718-9a33-4b161268eb34",
        "initial_consumption_type": "Flower",
        "value": "Blue Bastard",
        "strain_type": "Hybrid"
    },
    {
        "id": "6a85ca5d-4dc5-4bb7-8af8-eedb3b60e26b",
        "initial_consumption_type": "Flower",
        "value": "Blue Bayou",
        "strain_type": "Sativa"
    },
    {
        "id": "6a81c873-5a39-4428-9bb0-fa8d25dd2c96",
        "initial_consumption_type": "Flower",
        "value": "Blue Boy",
        "strain_type": "Hybrid"
    },
    {
        "id": "67112d75-23a0-4b16-b866-4976bb22ddab",
        "initial_consumption_type": "Flower",
        "value": "Blue Champagne",
        "strain_type": "Hybrid"
    },
    {
        "id": "547f219d-5c4d-424a-8d43-ef56145e56c3",
        "initial_consumption_type": "Flower",
        "value": "Blue Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "d19f5787-2eda-423f-b17d-67e786708454",
        "initial_consumption_type": "Flower",
        "value": "Blue Crack",
        "strain_type": "Hybrid"
    },
    {
        "id": "a7079cfa-f875-43e6-919a-aad0d94066ce",
        "initial_consumption_type": "Flower",
        "value": "Blue Diamond",
        "strain_type": "Hybrid"
    },
    {
        "id": "18fc4c02-5560-4951-bd0c-d3d21e1d6bba",
        "initial_consumption_type": "Flower",
        "value": "Blue Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "44bbf474-3e1e-4cd6-8c55-1bab4cda30c7",
        "initial_consumption_type": "Flower",
        "value": "Blue Dragon",
        "strain_type": "Hybrid"
    },
    {
        "id": "92bf743b-0148-4a56-b9e9-fe0f361ec52d",
        "initial_consumption_type": "Flower",
        "value": "Blue Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "01c3707a-2398-4342-a12d-90dac89abcac",
        "initial_consumption_type": "Flower",
        "value": "Blue Dynamite",
        "strain_type": "Hybrid"
    },
    {
        "id": "89258e2a-a9fb-4150-a350-e44896902c71",
        "initial_consumption_type": "Flower",
        "value": "Blue God",
        "strain_type": "Indica"
    },
    {
        "id": "0a600b79-0c9a-42d0-a590-95f01f8a0682",
        "initial_consumption_type": "Flower",
        "value": "Blue Goo",
        "strain_type": "Hybrid"
    },
    {
        "id": "53ce6cca-d9ac-4983-89b8-796c3288d613",
        "initial_consumption_type": "Flower",
        "value": "Blue Hawaiian",
        "strain_type": "Hybrid"
    },
    {
        "id": "796741d9-0281-4432-b017-38e73428ab23",
        "initial_consumption_type": "Flower",
        "value": "Blue Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "b7f8463e-e680-414e-9987-71aa7586e297",
        "initial_consumption_type": "Flower",
        "value": "Blue Ivy",
        "strain_type": "Hybrid"
    },
    {
        "id": "300fea1e-d586-4b46-8f71-494a1013358c",
        "initial_consumption_type": "Flower",
        "value": "Blue Lights",
        "strain_type": "Hybrid"
    },
    {
        "id": "ba7351c3-fa1a-4aa1-8efd-c39d8ca33575",
        "initial_consumption_type": "Flower",
        "value": "Blue Magoo",
        "strain_type": "Hybrid"
    },
    {
        "id": "295cd42e-29ab-45d4-8455-4d98400d0bdd",
        "initial_consumption_type": "Flower",
        "value": "Blue Moon Rocks",
        "strain_type": "Hybrid"
    },
    {
        "id": "4355fa7f-3c69-4491-800e-21e32c7bd6aa",
        "initial_consumption_type": "Flower",
        "value": "Blue Moonshine",
        "strain_type": "Indica"
    },
    {
        "id": "de1da367-af18-4466-82fa-216762fe712f",
        "initial_consumption_type": "Flower",
        "value": "Blue Mystic",
        "strain_type": "Hybrid"
    },
    {
        "id": "c7ace7c7-c115-43e2-8df5-4a28c183de69",
        "initial_consumption_type": "Flower",
        "value": "Blue OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "5f12b278-2025-4dc4-a69d-77891e7db949",
        "initial_consumption_type": "Flower",
        "value": "Blue Rhino",
        "strain_type": "Hybrid"
    },
    {
        "id": "6203edab-fe8e-4f02-9212-be7a8e24c1ba",
        "initial_consumption_type": "Flower",
        "value": "Blue Satellite",
        "strain_type": "Sativa"
    },
    {
        "id": "6645f100-4bee-4733-a1f5-5b8cedc0df8f",
        "initial_consumption_type": "Flower",
        "value": "Blue Satellite #2",
        "strain_type": "Sativa"
    },
    {
        "id": "a25de36b-1790-4a1b-a7d2-97b70db398c1",
        "initial_consumption_type": "Flower",
        "value": "Blue Thunder",
        "strain_type": "Hybrid"
    },
    {
        "id": "b14ba1e5-cba3-4040-a584-b2b3ae41fb28",
        "initial_consumption_type": "Flower",
        "value": "Blue Train",
        "strain_type": "Hybrid"
    },
    {
        "id": "0fee9599-8d71-4bba-9d1b-cf675297f52a",
        "initial_consumption_type": "Flower",
        "value": "Blue Venom",
        "strain_type": "Hybrid"
    },
    {
        "id": "805c80ce-75e7-4b25-9ec5-490142a8fef3",
        "initial_consumption_type": "Flower",
        "value": "Blue Widow",
        "strain_type": "Hybrid"
    },
    {
        "id": "2dfa02fd-3e7b-4167-994f-9ced47dc4dcc",
        "initial_consumption_type": "Flower",
        "value": "Blueberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "c9de26b3-43eb-4a94-be27-c0b2b79b8529",
        "initial_consumption_type": "Flower",
        "value": "Blueberry AK",
        "strain_type": "Sativa"
    },
    {
        "id": "99fc7abb-cc5f-4401-a47e-6dab900729dd",
        "initial_consumption_type": "Flower",
        "value": "Blueberry Cheesecake",
        "strain_type": "Hybrid"
    },
    {
        "id": "a8fed9b9-7ce0-473a-8f0e-864b92dbf0fb",
        "initial_consumption_type": "Flower",
        "value": "Blueberry Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "5882acfc-9c3f-4acc-bf91-1e30c9ee5c98",
        "initial_consumption_type": "Flower",
        "value": "Blueberry Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "fb3d340e-50e4-46c2-82e9-efa7a7f1fe7a",
        "initial_consumption_type": "Flower",
        "value": "Blueberry Headband",
        "strain_type": "Hybrid"
    },
    {
        "id": "8a00318e-2953-47c6-bd6d-469d14089aa0",
        "initial_consumption_type": "Flower",
        "value": "Blueberry Kush",
        "strain_type": "Indica"
    },
    {
        "id": "f87bd816-731f-4b2f-9cf5-ac215755a292",
        "initial_consumption_type": "Flower",
        "value": "Blueberry x Hash Plant",
        "strain_type": "Hybrid"
    },
    {
        "id": "6debce78-0f5b-40c5-b73b-973b8640c629",
        "initial_consumption_type": "Flower",
        "value": "Blueberry Yum Yum",
        "strain_type": "Hybrid"
    },
    {
        "id": "cd498dd5-f7ef-44f8-90f5-b46b559ac0e1",
        "initial_consumption_type": "Flower",
        "value": "Blurberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "fc1decb8-3152-4eb3-b110-59b251b4a59c",
        "initial_consumption_type": "Flower",
        "value": "BLZ Bud",
        "strain_type": "Hybrid"
    },
    {
        "id": "26dfb862-2bbe-4213-93d5-bf39ab847e9c",
        "initial_consumption_type": "Flower",
        "value": "BOG L.S.D",
        "strain_type": "Hybrid"
    },
    {
        "id": "299ae9af-df31-4ac6-95d8-62829dcfdb43",
        "initial_consumption_type": "Flower",
        "value": "Boggle Gum",
        "strain_type": "Hybrid"
    },
    {
        "id": "a8092522-e91f-4375-b71f-97ea6a37fca4",
        "initial_consumption_type": "Flower",
        "value": "Bordello",
        "strain_type": "Hybrid"
    },
    {
        "id": "6322e129-a0a6-4bde-baf3-5d56e04f6058",
        "initial_consumption_type": "Flower",
        "value": "Boysenberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "06595b1f-ea60-46e3-b49a-7fe5ccebe923",
        "initial_consumption_type": "Flower",
        "value": "Brainstorm Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "139c2c84-fe42-4f08-aee3-4657243cd14c",
        "initial_consumption_type": "Flower",
        "value": "Brazilian Amazonian",
        "strain_type": "Indica"
    },
    {
        "id": "ecfd205d-38be-4e46-a7f8-5255fba21625",
        "initial_consumption_type": "Flower",
        "value": "Brett’s Passion",
        "strain_type": "Hybrid"
    },
    {
        "id": "c6005fbe-1536-4a5e-a23b-2f999ba3c8cb",
        "initial_consumption_type": "Flower",
        "value": "Broke Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "7f4b993f-55c7-44d7-b362-5c5521adb643",
        "initial_consumption_type": "Flower",
        "value": "Bruce Banner",
        "strain_type": "Hybrid"
    },
    {
        "id": "a50b62af-ff56-4aad-9b67-ede7ec6891ea",
        "initial_consumption_type": "Flower",
        "value": "Bruce Banner #3",
        "strain_type": "Hybrid"
    },
    {
        "id": "27286091-bdae-43a6-a43a-fb96d060dc20",
        "initial_consumption_type": "Flower",
        "value": "Bubba Kush",
        "strain_type": "Indica"
    },
    {
        "id": "5d14c6ff-9d62-44d2-8d71-a50a1ec02315",
        "initial_consumption_type": "Flower",
        "value": "Bubba OG",
        "strain_type": "Indica"
    },
    {
        "id": "c5ba2605-452d-4401-bf73-1259f11b6038",
        "initial_consumption_type": "Flower",
        "value": "Bubble Gum",
        "strain_type": "Hybrid"
    },
    {
        "id": "ed5b159b-13ec-4416-aa29-851c170aee27",
        "initial_consumption_type": "Flower",
        "value": "Bubble Hash",
        "strain_type": "Hybrid"
    },
    {
        "id": "f98da77c-edab-4f5a-b6ab-dd57987f7121",
        "initial_consumption_type": "Flower",
        "value": "Bubble Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "1a6cb490-f058-4da3-b479-189665a86870",
        "initial_consumption_type": "Flower",
        "value": "Bubbleberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "659f88ce-08cf-4c5a-9b35-3d6a9d0e21e6",
        "initial_consumption_type": "Flower",
        "value": "Bubblegun",
        "strain_type": "Hybrid"
    },
    {
        "id": "304e6677-5855-44fe-9192-2818e59110c6",
        "initial_consumption_type": "Flower",
        "value": "Buddahs Love",
        "strain_type": "Hybrid"
    },
    {
        "id": "5ad87fdc-e758-4acb-b2e9-157658ebe155",
        "initial_consumption_type": "Flower",
        "value": "Buddha’s Sister",
        "strain_type": "Indica"
    },
    {
        "id": "1d4e0cbc-d740-4622-9044-59395f63855b",
        "initial_consumption_type": "Flower",
        "value": "Burmese Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "5ca66e27-c0ff-45f7-b359-fdbf77dda58a",
        "initial_consumption_type": "Flower",
        "value": "Butterscotch",
        "strain_type": "Indica"
    },
    {
        "id": "8e7fbe19-55ce-4f5e-b29c-298e8fb3a59a",
        "initial_consumption_type": "Flower",
        "value": "C13 Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "93238b52-f9fd-42be-904e-64a76663edb2",
        "initial_consumption_type": "Flower",
        "value": "C4",
        "strain_type": "Hybrid"
    },
    {
        "id": "ac6a3d5a-445e-434e-a616-962aa5afcc4c",
        "initial_consumption_type": "Flower",
        "value": "C4 Hash",
        "strain_type": "Sativa"
    },
    {
        "id": "b33d12e0-0e52-4372-9836-d4dba51d1935",
        "initial_consumption_type": "Flower",
        "value": "Caboose",
        "strain_type": "Indica"
    },
    {
        "id": "b64ab850-a3de-4ab1-893c-de20065fe81d",
        "initial_consumption_type": "Flower",
        "value": "Cadillac Purple",
        "strain_type": "Indica"
    },
    {
        "id": "dd9447a6-7cfe-4e8d-b77d-961a286b993d",
        "initial_consumption_type": "Flower",
        "value": "Cali Big Bud",
        "strain_type": "Hybrid"
    },
    {
        "id": "da321927-c6f1-4b1b-849a-b341bf87ff22",
        "initial_consumption_type": "Flower",
        "value": "Cali Gold",
        "strain_type": "Hybrid"
    },
    {
        "id": "2e228096-60f5-4d56-9f58-2905e8583639",
        "initial_consumption_type": "Flower",
        "value": "Cali Goo",
        "strain_type": "Indica"
    },
    {
        "id": "f7b76f02-cc59-479a-a9cf-e72f269ee6af",
        "initial_consumption_type": "Flower",
        "value": "Cali Hash Plant",
        "strain_type": "Indica"
    },
    {
        "id": "347ca8db-a273-4210-bb3e-89376552a6e7",
        "initial_consumption_type": "Flower",
        "value": "Cali Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "3a05848c-c803-492e-bf60-65bd0ebf0bf9",
        "initial_consumption_type": "Flower",
        "value": "Cali Orange Bud",
        "strain_type": "Hybrid"
    },
    {
        "id": "c4ede49f-ae38-4a4a-94e5-076dfb5ebc4f",
        "initial_consumption_type": "Flower",
        "value": "California Dream",
        "strain_type": "Indica"
    },
    {
        "id": "c2ed4ebe-b2e6-4d42-a56f-276b9321094c",
        "initial_consumption_type": "Flower",
        "value": "California Orange",
        "strain_type": "Hybrid"
    },
    {
        "id": "e09e968a-3cb0-49c0-9700-afaed29e3e63",
        "initial_consumption_type": "Flower",
        "value": "California Pot",
        "strain_type": "Hybrid"
    },
    {
        "id": "81c99e8b-89a3-4d9d-a8c5-8a620ac4d605",
        "initial_consumption_type": "Flower",
        "value": "Candy Jack",
        "strain_type": "Sativa"
    },
    {
        "id": "c592a6c8-d9f4-4f5c-b580-e739e2f6edc0",
        "initial_consumption_type": "Flower",
        "value": "Candyland",
        "strain_type": "Hybrid"
    },
    {
        "id": "ee35ac70-bef3-4836-b39c-318f942679fe",
        "initial_consumption_type": "Flower",
        "value": "Canna Berry",
        "strain_type": "Hybrid"
    },
    {
        "id": "70ed3998-1586-474e-b4ee-bd6861097072",
        "initial_consumption_type": "Flower",
        "value": "Cannadential",
        "strain_type": "Hybrid"
    },
    {
        "id": "863356fb-67b5-49ad-aec7-3ed8aba2a183",
        "initial_consumption_type": "Flower",
        "value": "Cannalope Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "f0cc85b3-d59e-4ec5-a790-94e86c75a2ee",
        "initial_consumption_type": "Flower",
        "value": "Cannatonic",
        "strain_type": "Hybrid"
    },
    {
        "id": "41c34ae1-322c-48f4-94fb-8728b7f55162",
        "initial_consumption_type": "Flower",
        "value": "Caramelicious",
        "strain_type": "Hybrid"
    },
    {
        "id": "be70c5a4-a6ee-4f2b-a0f7-fb14845753ad",
        "initial_consumption_type": "Flower",
        "value": "Caribbean Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "533a74b0-5ca4-407d-b9fa-b717d0e2ab7e",
        "initial_consumption_type": "Flower",
        "value": "Carnage",
        "strain_type": "Indica"
    },
    {
        "id": "1ca063d6-e1c5-4f4f-b0f8-7c0639738f08",
        "initial_consumption_type": "Flower",
        "value": "Casey Jones",
        "strain_type": "Hybrid"
    },
    {
        "id": "f6b4262c-6639-4b00-914d-f659d1d50c71",
        "initial_consumption_type": "Flower",
        "value": "Cat Piss",
        "strain_type": "Sativa"
    },
    {
        "id": "d7bbfa25-0eca-4c28-95ba-13a1d7187a57",
        "initial_consumption_type": "Flower",
        "value": "Cataract Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "744e4885-2345-488f-bb42-588d42eb7fe3",
        "initial_consumption_type": "Flower",
        "value": "Cate Harrington",
        "strain_type": "Indica"
    },
    {
        "id": "eabda78c-6b45-4e4d-bc46-8d511ce6afdd",
        "initial_consumption_type": "Flower",
        "value": "Caviar",
        "strain_type": "Indica"
    },
    {
        "id": "d89295af-a78f-438a-a4d7-a0bcc9a96dcb",
        "initial_consumption_type": "Flower",
        "value": "Cenax",
        "strain_type": "Hybrid"
    },
    {
        "id": "33df70d9-6d3c-44a9-af7e-43ecfc5eecc5",
        "initial_consumption_type": "Flower",
        "value": "CH9",
        "strain_type": "Sativa"
    },
    {
        "id": "d3724bcf-45d1-433c-934a-36f521448eed",
        "initial_consumption_type": "Flower",
        "value": "Champagne Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "bd36dc02-97f0-4e49-bbe6-53e28e80e294",
        "initial_consumption_type": "Flower",
        "value": "Charlie Sheen",
        "strain_type": "Indica"
    },
    {
        "id": "414c0623-e6f8-4f56-ae1f-88efdca8defb",
        "initial_consumption_type": "Flower",
        "value": "Charlotte’s Web",
        "strain_type": "Sativa"
    },
    {
        "id": "8b2680af-919f-4513-9474-c5d7bc7c8536",
        "initial_consumption_type": "Flower",
        "value": "Cheddar Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "f1972336-c36d-4739-9b8d-e2b94b0b9db5",
        "initial_consumption_type": "Flower",
        "value": "Cheese",
        "strain_type": "Indica"
    },
    {
        "id": "9999e7a3-8f66-43ee-b596-59e34a2c7b59",
        "initial_consumption_type": "Flower",
        "value": "Cheese Quake",
        "strain_type": "Indica"
    },
    {
        "id": "6f68b5c1-4489-4cfb-ba3b-5b87687eb863",
        "initial_consumption_type": "Flower",
        "value": "Cheesewreck",
        "strain_type": "Hybrid"
    },
    {
        "id": "d6a2ce2a-7908-41df-92f0-18196d99318f",
        "initial_consumption_type": "Flower",
        "value": "Chem 91",
        "strain_type": "Sativa"
    },
    {
        "id": "71de9be6-19ea-4f75-9a72-a991fbc1c8a3",
        "initial_consumption_type": "Flower",
        "value": "Chem Berry",
        "strain_type": "Hybrid"
    },
    {
        "id": "f4d6d90a-3c9a-468e-9c38-c889f5a7293e",
        "initial_consumption_type": "Flower",
        "value": "Chem Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "a324a7f2-6064-4396-8e73-2010dfcd8edc",
        "initial_consumption_type": "Flower",
        "value": "Chem Scout",
        "strain_type": "Indica"
    },
    {
        "id": "10b6e9df-f266-484e-8259-09d282fa8238",
        "initial_consumption_type": "Flower",
        "value": "Chemdawg",
        "strain_type": "Hybrid"
    },
    {
        "id": "4152442d-5ebb-4cc5-9952-7339aeb8a17e",
        "initial_consumption_type": "Flower",
        "value": "Chemdawg 4",
        "strain_type": "Indica"
    },
    {
        "id": "b1c2585a-806b-4c7e-8913-665d696e045b",
        "initial_consumption_type": "Flower",
        "value": "Chemdog",
        "strain_type": "Sativa"
    },
    {
        "id": "8e74542f-c77a-449d-a3f8-c5b4873bbb8a",
        "initial_consumption_type": "Flower",
        "value": "Chernobyl",
        "strain_type": "Hybrid"
    },
    {
        "id": "04ce6f0a-7beb-4b4b-8ab0-b8a4427145e3",
        "initial_consumption_type": "Flower",
        "value": "Cherry AK-47",
        "strain_type": "Hybrid"
    },
    {
        "id": "f2e224fe-df67-4b82-9a49-de7898797287",
        "initial_consumption_type": "Flower",
        "value": "Cherry Bomb",
        "strain_type": "Hybrid"
    },
    {
        "id": "90816caf-8f66-46de-bd2d-ebf5fb9df1f0",
        "initial_consumption_type": "Flower",
        "value": "Cherry Cough Syrup",
        "strain_type": "Indica"
    },
    {
        "id": "d82649aa-b7c3-4b45-a091-a351d9cc1589",
        "initial_consumption_type": "Flower",
        "value": "Cherry Kola",
        "strain_type": "Indica"
    },
    {
        "id": "dc541d64-9187-4d26-af74-d1310d07a0c8",
        "initial_consumption_type": "Flower",
        "value": "Cherry Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "63fe04aa-1f09-43ec-b4ef-a773428ba461",
        "initial_consumption_type": "Flower",
        "value": "Cherry Limeade",
        "strain_type": "Hybrid"
    },
    {
        "id": "65a3e718-df12-4826-ac03-4db77f046ccc",
        "initial_consumption_type": "Flower",
        "value": "Cherry Pie",
        "strain_type": "Indica"
    },
    {
        "id": "78980e58-469a-4e3b-92c1-52ae63f9d01d",
        "initial_consumption_type": "Flower",
        "value": "Chiesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "324ab294-1379-4469-8948-4cda9cb46c18",
        "initial_consumption_type": "Flower",
        "value": "Chocolate Chunk",
        "strain_type": "Indica"
    },
    {
        "id": "a41ebe28-2aca-4d28-bd93-0601b678ce81",
        "initial_consumption_type": "Flower",
        "value": "Chocolate Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "1455399d-8d58-4450-9900-0c24dbbc3c31",
        "initial_consumption_type": "Flower",
        "value": "Chocolope",
        "strain_type": "Hybrid"
    },
    {
        "id": "1d74f7f7-4c8a-4ff9-83f8-4e2fe104f1a5",
        "initial_consumption_type": "Flower",
        "value": "Chronic",
        "strain_type": "Sativa"
    },
    {
        "id": "af1b214c-c37c-4dfa-b80e-8f17b85ac191",
        "initial_consumption_type": "Flower",
        "value": "Church OG",
        "strain_type": "Indica"
    },
    {
        "id": "6238cb31-9d53-418f-907b-fa9943b52d02",
        "initial_consumption_type": "Flower",
        "value": "Cinderella 99",
        "strain_type": "Hybrid"
    },
    {
        "id": "ed7acaca-5e5b-411a-b305-23ff06ecc2bf",
        "initial_consumption_type": "Flower",
        "value": "Cinex",
        "strain_type": "Hybrid"
    },
    {
        "id": "e6ec0013-f0c6-48be-8698-b10ddef3effa",
        "initial_consumption_type": "Flower",
        "value": "Citrus Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "9cbcc44e-fe3f-4014-9e3f-c5fa0ae290b7",
        "initial_consumption_type": "Flower",
        "value": "Cold Creek Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "3c902687-cbc6-4b8e-a0b6-d5e7218db20e",
        "initial_consumption_type": "Flower",
        "value": "Concord Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "bfb72f81-9718-4bb1-80eb-a8416eded991",
        "initial_consumption_type": "Flower",
        "value": "Confidential Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "d9ba26ad-51af-407b-9a0b-f538d2c37f4e",
        "initial_consumption_type": "Flower",
        "value": "Connie Chung",
        "strain_type": "Hybrid"
    },
    {
        "id": "0a93698c-22cf-475b-ba59-55ce448141b2",
        "initial_consumption_type": "Flower",
        "value": "Corleone Kush",
        "strain_type": "Indica"
    },
    {
        "id": "552036ae-e3ff-4963-8725-787678417fb3",
        "initial_consumption_type": "Flower",
        "value": "Cotton Candy",
        "strain_type": "Sativa"
    },
    {
        "id": "bc27937f-a2e8-49cc-838c-d19b12a8716d",
        "initial_consumption_type": "Flower",
        "value": "Cotton Candy Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "733d1844-130f-43de-95f8-82fa4632577e",
        "initial_consumption_type": "Flower",
        "value": "Cracker Jack",
        "strain_type": "Sativa"
    },
    {
        "id": "586e561c-121b-42e3-ae64-a86b73dc839e",
        "initial_consumption_type": "Flower",
        "value": "Cranberry Kush",
        "strain_type": "Indica"
    },
    {
        "id": "66f8cba2-aa94-41f4-80c6-f21a2dd37776",
        "initial_consumption_type": "Flower",
        "value": "Cream Caramel",
        "strain_type": "Hybrid"
    },
    {
        "id": "f1aaf405-6ae7-4339-955d-1dd3ad804f3a",
        "initial_consumption_type": "Flower",
        "value": "Crimea Blue",
        "strain_type": "Hybrid"
    },
    {
        "id": "4bdf8576-c890-414b-abb1-8608331046a7",
        "initial_consumption_type": "Flower",
        "value": "Critical Bilbo",
        "strain_type": "Hybrid"
    },
    {
        "id": "71d772eb-48bf-4910-a6f3-7c771ad58281",
        "initial_consumption_type": "Flower",
        "value": "Critical Mass",
        "strain_type": "Indica"
    },
    {
        "id": "5db61f0f-d479-4e35-8484-dd59a83dd600",
        "initial_consumption_type": "Flower",
        "value": "Crystal",
        "strain_type": "Hybrid"
    },
    {
        "id": "2a9c3aa7-215e-4653-946b-cf3834c504d5",
        "initial_consumption_type": "Flower",
        "value": "Crystal Coma",
        "strain_type": "Hybrid"
    },
    {
        "id": "cf07c4a5-2cf8-44c6-9164-a8ec678ab8a8",
        "initial_consumption_type": "Flower",
        "value": "Dae Dae’s Weed",
        "strain_type": "Sativa"
    },
    {
        "id": "33208690-6a8b-492f-b971-c14f2886e47d",
        "initial_consumption_type": "Flower",
        "value": "Dairy Queen",
        "strain_type": "Hybrid"
    },
    {
        "id": "28ac41eb-3e6c-4b80-b0b5-ed35f43f5561",
        "initial_consumption_type": "Flower",
        "value": "Danky Doodle",
        "strain_type": "Indica"
    },
    {
        "id": "c6e59004-0ecf-448c-bf7c-8ca4190e6fbf",
        "initial_consumption_type": "Flower",
        "value": "Dark Star",
        "strain_type": "Indica"
    },
    {
        "id": "184e1158-22b2-42e8-b8d7-c0676eb19516",
        "initial_consumption_type": "Flower",
        "value": "Darth Vader OG",
        "strain_type": "Indica"
    },
    {
        "id": "495a78de-c7da-45e6-9791-5206be33e037",
        "initial_consumption_type": "Flower",
        "value": "Dawg Daze",
        "strain_type": "Hybrid"
    },
    {
        "id": "fa4bac23-7d79-487b-bfed-1da956098039",
        "initial_consumption_type": "Flower",
        "value": "Deadhead OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "e248a993-427e-498d-bf65-c87090cd1870",
        "initial_consumption_type": "Flower",
        "value": "Deadman",
        "strain_type": "Hybrid"
    },
    {
        "id": "ed77a464-c717-457a-a106-dbc2fd5e710e",
        "initial_consumption_type": "Flower",
        "value": "Death Star",
        "strain_type": "Indica"
    },
    {
        "id": "d576b9e7-87c1-466d-9a8b-aeb5c7485634",
        "initial_consumption_type": "Flower",
        "value": "Deathstar OG",
        "strain_type": "Indica"
    },
    {
        "id": "b13d09ea-dfe1-48c8-93a4-81cabe5f092d",
        "initial_consumption_type": "Flower",
        "value": "Deep Purple",
        "strain_type": "Indica"
    },
    {
        "id": "f823e096-8799-4ddd-9d6e-006850f8343f",
        "initial_consumption_type": "Flower",
        "value": "Diablo",
        "strain_type": "Indica"
    },
    {
        "id": "90cbd59e-450e-4bf5-b278-0e7700b63e8d",
        "initial_consumption_type": "Flower",
        "value": "Diamond OG",
        "strain_type": "Indica"
    },
    {
        "id": "7e0c6392-7667-4d79-bc98-56d9ace16f65",
        "initial_consumption_type": "Flower",
        "value": "Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "811f79a8-3b9c-4662-9ac3-45b5f5b194cc",
        "initial_consumption_type": "Flower",
        "value": "Diesel Duff",
        "strain_type": "Hybrid"
    },
    {
        "id": "df27dd73-777e-489b-a4df-9b73d9ff2e8c",
        "initial_consumption_type": "",
        "value": "Dixie Dew Drops",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "4399e15c-a63c-41db-bc9f-7ce5dd5ef523",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Lemonade",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "63331b67-6a05-4603-b429-32eba4921087",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Mixed Berry",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "15ba7022-5e0d-4afd-90e4-0b038a7dadb3",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Old-Fashioned Sarsaparilla",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "4e7202e9-47e4-46db-aecb-bf93724c4453",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Peach",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "ba081ea2-8e01-4298-aa23-144dc5cab58f",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Pomegranate",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "6565c5e9-2be3-4f15-99b4-251a825a7d3c",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Sparkling Blueberry",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "28868a5f-0796-402b-8957-a1c7574f12e8",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Sparkling Grapefruit",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "6fdc9d36-1d32-4dfa-b7e4-abda1982e6b6",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Sparkling Mandarin",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "c7e7c949-0616-4edd-a591-0901f5587db1",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Sparkling Red Currant",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "0863dbfe-3029-4a17-b49e-e086b4aef233",
        "initial_consumption_type": "",
        "value": "Dixie Elixirs Sweet Tea",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "0aee3f2f-793a-4d1a-8ccb-e3bdaf0db752",
        "initial_consumption_type": "",
        "value": "Dixie Med-a-Mints",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "6c0c903c-f07e-4dea-9c17-9ad47068ce27",
        "initial_consumption_type": "",
        "value": "Dixie Medicated Chocolate Truffles",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "0f3e8562-b36f-4b02-8421-dad31b499ff5",
        "initial_consumption_type": "",
        "value": "Dixie Medicated Crispy Rice Treats",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "20903d78-e775-4163-84b0-f82f57f3d7b3",
        "initial_consumption_type": "",
        "value": "Dixie Medicated Fruit Lozenges",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "58f8eae3-2d82-44aa-a42a-653435cac128",
        "initial_consumption_type": "",
        "value": "Dixie Scrips A.M. Focus",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "8bc62351-72e3-4bfd-bd72-ffb2a827bd0a",
        "initial_consumption_type": "",
        "value": "Dixie Scrips General Pain Relief",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "74aebdfd-a273-45a4-9ca2-55949176f92b",
        "initial_consumption_type": "",
        "value": "Dixie Scrips P.M. Sleep",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "8d032162-e49a-46fb-9c90-e8ab3d55dff9",
        "initial_consumption_type": "",
        "value": "Dixie’s Colorado Bar",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "460fc709-7234-437c-a9c2-24f76f9f19fe",
        "initial_consumption_type": "Flower",
        "value": "DJ Short Blueberry",
        "strain_type": "Indica"
    },
    {
        "id": "5195902b-c01d-4fd1-9824-bf7bc8a4231f",
        "initial_consumption_type": "Flower",
        "value": "Django",
        "strain_type": "Sativa"
    },
    {
        "id": "b196547e-3d85-4bd0-9ef4-816e7a9efa56",
        "initial_consumption_type": "Flower",
        "value": "Domina",
        "strain_type": "Sativa"
    },
    {
        "id": "215ee4d7-cf94-4282-ab3b-8d4290d8bab6",
        "initial_consumption_type": "Flower",
        "value": "Domino",
        "strain_type": "Indica"
    },
    {
        "id": "6480c30b-8109-46e9-a131-d538474d7351",
        "initial_consumption_type": "Flower",
        "value": "Donk",
        "strain_type": "Indica"
    },
    {
        "id": "f152a17d-90ea-47ef-ba82-6724d6e0d54b",
        "initial_consumption_type": "Flower",
        "value": "Donna OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "56a86bb5-0ec3-490a-bb9e-8b2a3a545df6",
        "initial_consumption_type": "Flower",
        "value": "Dopium",
        "strain_type": "Hybrid"
    },
    {
        "id": "e7bb1c20-b87d-40bd-94b7-214963914e51",
        "initial_consumption_type": "Flower",
        "value": "Dorit",
        "strain_type": "Hybrid"
    },
    {
        "id": "e5f7ae73-a887-4411-abde-7b916a4f0783",
        "initial_consumption_type": "Flower",
        "value": "Double Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "34fcaa30-746b-497f-b3da-6be1ca63293c",
        "initial_consumption_type": "Flower",
        "value": "Double Dutch",
        "strain_type": "Hybrid"
    },
    {
        "id": "991f5baa-e183-4dec-aa0b-eb4499d2521b",
        "initial_consumption_type": "Flower",
        "value": "Doyon Bud",
        "strain_type": "Sativa"
    },
    {
        "id": "e2e07c76-5270-4fbb-9c12-9c8c6fd57057",
        "initial_consumption_type": "Flower",
        "value": "Dr. Grinspoon",
        "strain_type": "Hybrid"
    },
    {
        "id": "fbbc9517-0c83-4602-a02f-a4874cddc486",
        "initial_consumption_type": "Flower",
        "value": "Draztic",
        "strain_type": "Sativa"
    },
    {
        "id": "e0df313e-600e-48b0-b3e1-fc93d46a32f9",
        "initial_consumption_type": "Flower",
        "value": "Dreadlock",
        "strain_type": "Sativa"
    },
    {
        "id": "199878d2-6357-4abd-8fcd-ad31a500f1c5",
        "initial_consumption_type": "Flower",
        "value": "Dream Queen",
        "strain_type": "Indica"
    },
    {
        "id": "7c76747b-9798-4d1d-8ce5-f325d742aca3",
        "initial_consumption_type": "Flower",
        "value": "Duke Nukem",
        "strain_type": "Hybrid"
    },
    {
        "id": "4a3888e6-b806-43cc-87c4-291269b80000",
        "initial_consumption_type": "Flower",
        "value": "Durban Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "e32e4eb7-27f5-4bbf-872f-e3b7b351287e",
        "initial_consumption_type": "Flower",
        "value": "Durban Poison",
        "strain_type": "Hybrid"
    },
    {
        "id": "28d52dc2-7bfe-4d32-be8d-a25ff291c887",
        "initial_consumption_type": "Flower",
        "value": "Dutch Dragon",
        "strain_type": "Hybrid"
    },
    {
        "id": "3b8eaa1b-f9ae-4b8a-bd11-8dacc1f25254",
        "initial_consumption_type": "Flower",
        "value": "Dutch Hawaiian",
        "strain_type": "Sativa"
    },
    {
        "id": "a64b77de-5d6e-41d3-8674-407c8ae47c3c",
        "initial_consumption_type": "Flower",
        "value": "Dutch Treat",
        "strain_type": "Hybrid"
    },
    {
        "id": "97740108-ef3a-4d75-bc93-780dbccc9530",
        "initial_consumption_type": "Flower",
        "value": "Dutch Treat Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "cc62aedd-04f0-482f-8ff9-bbe0d6d77913",
        "initial_consumption_type": "Flower",
        "value": "Dynamite",
        "strain_type": "Indica"
    },
    {
        "id": "ea579b2e-945c-4965-9d34-43dab5a039db",
        "initial_consumption_type": "Flower",
        "value": "Early Girl",
        "strain_type": "Hybrid"
    },
    {
        "id": "9e47fc84-0547-4f35-bb82-eee2f0ca1c7a",
        "initial_consumption_type": "Flower",
        "value": "Earthquake",
        "strain_type": "Hybrid"
    },
    {
        "id": "29708002-3d94-460a-9b8c-c0bacb04507b",
        "initial_consumption_type": "Flower",
        "value": "East Coast Sour Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "c4fb6bf3-3b9b-40be-8aa5-1cdae6120539",
        "initial_consumption_type": "Flower",
        "value": "Ed Rosenthal Super Bud",
        "strain_type": "Hybrid"
    },
    {
        "id": "4f4d965d-d287-48ce-ba9a-e6f8f835d53a",
        "initial_consumption_type": "Flower",
        "value": "Edelweiss",
        "strain_type": "Indica"
    },
    {
        "id": "a422a27c-2843-47b2-b3ab-791bfdd03b02",
        "initial_consumption_type": "",
        "value": "Edi Pure Blueberry Belts",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "28f529a2-ae97-4781-9aa9-1a007512e72e",
        "initial_consumption_type": "",
        "value": "Edi Pure Bubbly Cola Gummies",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "d3c48371-d3b3-4439-bc4f-4530c7ae00cd",
        "initial_consumption_type": "",
        "value": "Edi Pure Cherry Bombs",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "52828c93-ca54-4323-9856-feeda4a5029c",
        "initial_consumption_type": "",
        "value": "Edi Pure Cherry Cola Bottles",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "bc573662-9331-496d-b93b-6d69514ec413",
        "initial_consumption_type": "",
        "value": "Edi Pure Dried Pineapples",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "f2082339-71ee-4329-bade-fe7246544ce7",
        "initial_consumption_type": "",
        "value": "Edi Pure Gourmet Fruit Slices",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "40f3b5bc-6a68-4302-a134-fd3d7f1df2ed",
        "initial_consumption_type": "",
        "value": "Edi Pure Grapefruit Gummies",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "15dd83ac-55e7-4892-ac84-893a0b0ba1b6",
        "initial_consumption_type": "",
        "value": "Edi Pure Lemon Drops",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "68d06ecf-c115-40ff-871a-eab4ab8840d9",
        "initial_consumption_type": "",
        "value": "Edi Pure Mixed Nut Clusters",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "aad459d6-0673-47de-9b61-3150471b332b",
        "initial_consumption_type": "",
        "value": "Edi Pure Orange Slices",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "0d9f9bfe-cf44-4016-a66c-fff7800c5ca9",
        "initial_consumption_type": "",
        "value": "Edi Pure Peach Banana Rings",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "d3ca7f63-0c0c-46b1-b9a9-e015b6fd7e0f",
        "initial_consumption_type": "",
        "value": "Edi Pure Peach Tart",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "3cdfd64b-23c2-40e7-b7be-cf6d065efc5d",
        "initial_consumption_type": "",
        "value": "Edi Pure Rainbow Belts",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "95a4b86b-c295-4424-80d7-e59f285c69cf",
        "initial_consumption_type": "",
        "value": "Edi Pure Raspberry Gummies",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "e7475965-068d-46e4-8fee-1f3c900b0799",
        "initial_consumption_type": "",
        "value": "Edi Pure Red Delicious Apples",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "4282410e-e5e6-4f70-926b-a62c5b17fe37",
        "initial_consumption_type": "",
        "value": "Edi Pure Roasted Tomato Crackers",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "9d353cf6-c176-40f0-832e-084eb593eb62",
        "initial_consumption_type": "",
        "value": "Edi Pure Savory Roasted Garlic Crackers",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "0beb536f-6dba-4732-b5fb-93a67b098482",
        "initial_consumption_type": "",
        "value": "Edi Pure Sour Apple Belts",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "7f43e086-f30c-416e-b3c7-5d0e988e6587",
        "initial_consumption_type": "",
        "value": "Edi Pure Sour Apple Drops",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "d8bd7632-cea2-4eb1-8181-ae553cc40653",
        "initial_consumption_type": "",
        "value": "Edi Pure Sour Gummi Bears",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "bec134ce-e2cd-4253-b53c-e9639744ed5c",
        "initial_consumption_type": "",
        "value": "Edi Pure Strawberry Belts",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "081911e6-5aaf-4194-baeb-4b179e161c4b",
        "initial_consumption_type": "",
        "value": "Edi Pure Sweet N’ Sours",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "f6677a97-b619-40e9-9859-98dff2328112",
        "initial_consumption_type": "",
        "value": "Edi Pure Watermelon Tarts",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "850fce56-90f5-4735-ab6d-72637b0a659a",
        "initial_consumption_type": "",
        "value": "Edi Pure Wild Cherry Drops",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "6bcbbed7-a39f-419d-8c6c-f9e9bc730210",
        "initial_consumption_type": "Flower",
        "value": "El Jeffe",
        "strain_type": "Indica"
    },
    {
        "id": "08c4ee39-5eef-43fa-8f35-a2237cda4224",
        "initial_consumption_type": "Flower",
        "value": "El Nino",
        "strain_type": "Hybrid"
    },
    {
        "id": "012047d9-740e-49ab-97fb-a7c097adb666",
        "initial_consumption_type": "Flower",
        "value": "El-Na",
        "strain_type": "Hybrid"
    },
    {
        "id": "10d2144e-23ee-46ee-b7e3-866cac270ee3",
        "initial_consumption_type": "Flower",
        "value": "Eldorado",
        "strain_type": "Hybrid"
    },
    {
        "id": "2740769e-fa2d-45cc-9b13-d29ee593dc21",
        "initial_consumption_type": "Flower",
        "value": "Elephant",
        "strain_type": "Sativa"
    },
    {
        "id": "9dae74b5-4f66-4f01-9947-cb961e88cf4b",
        "initial_consumption_type": "Flower",
        "value": "Endless Sky",
        "strain_type": "Indica"
    },
    {
        "id": "f44e8a8c-5f64-4d1b-9625-ca59ca242f27",
        "initial_consumption_type": "Flower",
        "value": "Eran Almog",
        "strain_type": "Indica"
    },
    {
        "id": "64c660d6-270b-4346-a44a-ec192a2c83b5",
        "initial_consumption_type": "Flower",
        "value": "Erez",
        "strain_type": "Hybrid"
    },
    {
        "id": "9ea46c95-f8fd-40fa-9753-059f5fc5f58b",
        "initial_consumption_type": "Flower",
        "value": "ERSB Hash",
        "strain_type": "Hybrid"
    },
    {
        "id": "ce8e107a-9e15-48ea-abde-9ffb8aa0a0be",
        "initial_consumption_type": "Flower",
        "value": "Euphoria",
        "strain_type": "Hybrid"
    },
    {
        "id": "faf81c2f-a4f5-4322-a852-3993c2f36f07",
        "initial_consumption_type": "Flower",
        "value": "Ewok",
        "strain_type": "Hybrid"
    },
    {
        "id": "9a3e877d-d71a-4ae9-a008-b83ac91937c5",
        "initial_consumption_type": "Flower",
        "value": "Exodus Cheese",
        "strain_type": "Sativa"
    },
    {
        "id": "cfecec04-44f0-42cc-8b9a-d6bcb8963f31",
        "initial_consumption_type": "Flower",
        "value": "Fire Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "30313188-55c2-41f0-969e-3614d4133d28",
        "initial_consumption_type": "Flower",
        "value": "Fire OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "c5c5215d-b32b-4c4c-8999-73ce3bc14b87",
        "initial_consumption_type": "Flower",
        "value": "Firewalker OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "f4d1da79-cc78-4f23-9cc3-d446e15367b0",
        "initial_consumption_type": "Flower",
        "value": "Flo",
        "strain_type": "Hybrid"
    },
    {
        "id": "a597c12d-7d63-4941-b6fe-cceb4dba27c8",
        "initial_consumption_type": "Flower",
        "value": "Flowerbomb Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "6f686a2e-81f5-4358-94c6-58511725639d",
        "initial_consumption_type": "Flower",
        "value": "Fort Collins Cough",
        "strain_type": "Hybrid"
    },
    {
        "id": "0c2064ba-29e7-4e7e-a219-3a71b6f86a4b",
        "initial_consumption_type": "Flower",
        "value": "Fraggle Rock",
        "strain_type": "Hybrid"
    },
    {
        "id": "db330ae8-f8c7-49c6-9558-ba287f2afa24",
        "initial_consumption_type": "Flower",
        "value": "Frankenberry",
        "strain_type": "Indica"
    },
    {
        "id": "63a3e4a7-4aee-4db1-8ee2-9cfd40c86de7",
        "initial_consumption_type": "Flower",
        "value": "Free Leonard",
        "strain_type": "Hybrid"
    },
    {
        "id": "b11de238-cf67-443e-a8fc-577cf970bfd2",
        "initial_consumption_type": "Flower",
        "value": "Freezeland",
        "strain_type": "Indica"
    },
    {
        "id": "a356c3c0-2b41-4934-b411-fedb434f2cc8",
        "initial_consumption_type": "Flower",
        "value": "Frostbite",
        "strain_type": "Sativa"
    },
    {
        "id": "2028f0fd-1b00-4fbf-ad44-4da10575b6b2",
        "initial_consumption_type": "Flower",
        "value": "Frosty",
        "strain_type": "Indica"
    },
    {
        "id": "4dc4b0d5-37b0-4823-bf74-bfeb0e280f9b",
        "initial_consumption_type": "Flower",
        "value": "Fruity Pebbles",
        "strain_type": "Hybrid"
    },
    {
        "id": "58151bda-a955-4624-8b70-456ca85afdfb",
        "initial_consumption_type": "Flower",
        "value": "Fucking Incredible",
        "strain_type": "Indica"
    },
    {
        "id": "b6e8f23f-7db2-4e79-83aa-870c723acfdb",
        "initial_consumption_type": "Flower",
        "value": "Full Melt Hash",
        "strain_type": "Indica"
    },
    {
        "id": "e328d6e8-feba-44c4-bd7a-7fb343669113",
        "initial_consumption_type": "Flower",
        "value": "Funky Monkey",
        "strain_type": "Indica"
    },
    {
        "id": "55c15ce7-ff37-48b9-81fe-6a351aee1875",
        "initial_consumption_type": "Flower",
        "value": "Fuzzy Wuzzy",
        "strain_type": "Indica"
    },
    {
        "id": "82bc2e53-7ecc-471a-b84f-b50af70782d7",
        "initial_consumption_type": "Flower",
        "value": "G Stik “Amarillo”",
        "strain_type": "Sativa"
    },
    {
        "id": "707f8f28-980e-40d3-b625-d2badaa9fa2c",
        "initial_consumption_type": "Flower",
        "value": "G Stik “Orange”",
        "strain_type": "Hybrid"
    },
    {
        "id": "3488630f-1f73-4e1f-a61f-bc41da1b4fd8",
        "initial_consumption_type": "Flower",
        "value": "G Stik “RED”",
        "strain_type": "Indica"
    },
    {
        "id": "83c41fef-a6e5-46f2-b785-ef98bbf01ec4",
        "initial_consumption_type": "Flower",
        "value": "G Stik “Rosado”",
        "strain_type": "Sativa"
    },
    {
        "id": "9aa7f568-bb12-44c7-993c-975fd37807aa",
        "initial_consumption_type": "Flower",
        "value": "G Stik “Verde”",
        "strain_type": "Hybrid"
    },
    {
        "id": "e4878fa3-8c79-48f4-900e-62690785c094",
        "initial_consumption_type": "Flower",
        "value": "G Stik “Violeta”",
        "strain_type": "Indica"
    },
    {
        "id": "5c206a14-dcfb-4981-8c54-fa7de22b29a4",
        "initial_consumption_type": "Flower",
        "value": "G-14",
        "strain_type": "Hybrid"
    },
    {
        "id": "1aaa3842-2130-4246-8bfd-e9b828d6fa1f",
        "initial_consumption_type": "Flower",
        "value": "G13",
        "strain_type": "Indica"
    },
    {
        "id": "2eba8a0c-f7b7-45e6-822e-b38e492ef39a",
        "initial_consumption_type": "Flower",
        "value": "G13 Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "f1a09e3d-f64d-4e38-935c-8887bb2d994e",
        "initial_consumption_type": "Flower",
        "value": "GDP X Purple Urkle",
        "strain_type": "Indica"
    },
    {
        "id": "446db1f0-c9d6-4044-bf94-cc8aa6af3a10",
        "initial_consumption_type": "Flower",
        "value": "George Bush",
        "strain_type": "Hybrid"
    },
    {
        "id": "9255a428-56cc-4e4e-9e9b-79b1653e0b49",
        "initial_consumption_type": "Flower",
        "value": "Ghost OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "9bd8fbb5-9daf-48bf-b89e-4d2f875a055b",
        "initial_consumption_type": "Flower",
        "value": "Girl Scout Cookies",
        "strain_type": "Hybrid"
    },
    {
        "id": "f02f3386-c1bb-4dee-be3f-61fbc9a8f22d",
        "initial_consumption_type": "Flower",
        "value": "Glass Slipper",
        "strain_type": "Hybrid"
    },
    {
        "id": "01530f23-39f7-4560-bd88-3bc4efdb41c4",
        "initial_consumption_type": "Flower",
        "value": "Gnarsty",
        "strain_type": "Hybrid"
    },
    {
        "id": "620572b5-7b6b-4ea2-bcf2-ec1bedd031e0",
        "initial_consumption_type": "Flower",
        "value": "God Bud",
        "strain_type": "Indica"
    },
    {
        "id": "cf635b71-4e8f-41fb-8eff-16a9f526c856",
        "initial_consumption_type": "Flower",
        "value": "God’s Gift",
        "strain_type": "Hybrid"
    },
    {
        "id": "88d06df2-dc9c-47a7-9678-d0d20acd26aa",
        "initial_consumption_type": "Flower",
        "value": "God’s Treat",
        "strain_type": "Indica"
    },
    {
        "id": "3af04758-5c85-4fd2-9f13-dcfaab128ef3",
        "initial_consumption_type": "Flower",
        "value": "Godberry",
        "strain_type": "Indica"
    },
    {
        "id": "834f05e4-8b2d-4546-ab4c-e55b6009313f",
        "initial_consumption_type": "Flower",
        "value": "GodCrack",
        "strain_type": "Hybrid"
    },
    {
        "id": "c30f57a6-1a54-4705-bef7-7bd5597f189d",
        "initial_consumption_type": "Flower",
        "value": "Godfather OG",
        "strain_type": "Indica"
    },
    {
        "id": "51435be8-7643-489e-b039-774cdfc1fbf2",
        "initial_consumption_type": "Flower",
        "value": "Gog & Magog",
        "strain_type": "Indica"
    },
    {
        "id": "6bad4d95-4d6b-4c33-8653-54e64490563b",
        "initial_consumption_type": "Flower",
        "value": "Goldberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "8a5a1654-5ec7-407d-b9cf-f4b5df5c8527",
        "initial_consumption_type": "Flower",
        "value": "Golden Goat",
        "strain_type": "Hybrid"
    },
    {
        "id": "ed18dfc4-4caf-4c98-b2a9-de32ac4cd7ae",
        "initial_consumption_type": "Flower",
        "value": "Golden Jamaican Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "4c830924-f577-4c91-8f08-5dddb791c594",
        "initial_consumption_type": "Flower",
        "value": "Golden Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "b9076cd7-af7f-4264-859e-3bd4ccd933c7",
        "initial_consumption_type": "Flower",
        "value": "Goldwing",
        "strain_type": "Sativa"
    },
    {
        "id": "9db05f8d-2ec9-4d40-88ab-7fead7b18ce3",
        "initial_consumption_type": "Flower",
        "value": "Gorilla Glue #4",
        "strain_type": "Hybrid"
    },
    {
        "id": "c0d5cb82-99b5-4da3-813b-df00a50f6ff3",
        "initial_consumption_type": "Flower",
        "value": "Gracie Slick",
        "strain_type": "Indica"
    },
    {
        "id": "94ae8938-786a-4617-8016-863fc78fac54",
        "initial_consumption_type": "Flower",
        "value": "Grand Daddy Purp X Grape Gorilla",
        "strain_type": "Hybrid"
    },
    {
        "id": "d4a9de99-751e-41e6-86fe-36da234a5d6b",
        "initial_consumption_type": "Flower",
        "value": "Grand Daddy Purple",
        "strain_type": "Hybrid"
    },
    {
        "id": "52f9d5d9-43de-4543-835c-ead002f8fb54",
        "initial_consumption_type": "Flower",
        "value": "Grand Hindu",
        "strain_type": "Indica"
    },
    {
        "id": "bee7810f-8b37-4a68-9dce-ea2bca9c94f7",
        "initial_consumption_type": "Flower",
        "value": "Grand Hustle",
        "strain_type": "Hybrid"
    },
    {
        "id": "f3b97e96-a400-48e2-87aa-0f98b83ea84e",
        "initial_consumption_type": "Flower",
        "value": "Granddaddy Purple",
        "strain_type": "Indica"
    },
    {
        "id": "72342f68-fc91-494d-af2b-1bc7eccd431b",
        "initial_consumption_type": "Flower",
        "value": "Grape Ape",
        "strain_type": "Indica"
    },
    {
        "id": "31b8d569-0465-44f2-807f-8f62a85a72eb",
        "initial_consumption_type": "Flower",
        "value": "Grape Crush",
        "strain_type": "Indica"
    },
    {
        "id": "c81215a5-5d8a-4e45-9963-0901cd1d0286",
        "initial_consumption_type": "Flower",
        "value": "Grape God",
        "strain_type": "Hybrid"
    },
    {
        "id": "662b216a-7c3d-4da1-82cb-48a0bd27bba9",
        "initial_consumption_type": "Flower",
        "value": "Grape Krush",
        "strain_type": "Indica"
    },
    {
        "id": "89412359-a555-4f49-8b1a-486093fb9158",
        "initial_consumption_type": "Flower",
        "value": "Grape Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "c23ca0d1-e694-40cc-aa15-a130f879e493",
        "initial_consumption_type": "Flower",
        "value": "Grape Skunk",
        "strain_type": "Indica"
    },
    {
        "id": "e0ff6dc6-773d-498c-abe1-ce5de92983fd",
        "initial_consumption_type": "Flower",
        "value": "Grape Sorbet",
        "strain_type": "Sativa"
    },
    {
        "id": "9c5ff32f-59d2-42b1-9e41-11d4c24373fd",
        "initial_consumption_type": "Flower",
        "value": "Grapealicious",
        "strain_type": "Sativa"
    },
    {
        "id": "fe14d2a3-a878-4b4f-90e6-80624cfcb90e",
        "initial_consumption_type": "Flower",
        "value": "Grapefruit",
        "strain_type": "Sativa"
    },
    {
        "id": "ce91f971-2f2d-45c0-8a79-f7c902f88334",
        "initial_consumption_type": "Flower",
        "value": "Grapefruit Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "8d4add7a-0a5b-4b69-b0f2-d6e10907d75d",
        "initial_consumption_type": "Flower",
        "value": "Grapefruit Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "e4ac95fa-f906-4ecd-bf52-65280fa2b5ae",
        "initial_consumption_type": "Flower",
        "value": "Grapefruit Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "44525311-d79f-42b0-8991-a68510917f9a",
        "initial_consumption_type": "Flower",
        "value": "GrapeStomper x Sour Candy",
        "strain_type": "Hybrid"
    },
    {
        "id": "430d2275-8455-4708-a8b7-f45151dba562",
        "initial_consumption_type": "Flower",
        "value": "Gravity",
        "strain_type": "Indica"
    },
    {
        "id": "87608cec-0cb9-4104-9d5b-038115913add",
        "initial_consumption_type": "Flower",
        "value": "Great White",
        "strain_type": "Hybrid"
    },
    {
        "id": "9f4d7e81-14cf-430f-9620-45706692b96c",
        "initial_consumption_type": "Flower",
        "value": "Great White Shark",
        "strain_type": "Hybrid"
    },
    {
        "id": "702862ad-6827-4b35-8531-9ec958b75c2e",
        "initial_consumption_type": "Flower",
        "value": "Green -O- Matic",
        "strain_type": "Indica"
    },
    {
        "id": "438a64fe-edf5-44c0-89a7-960c3af8822e",
        "initial_consumption_type": "Flower",
        "value": "Green Beem",
        "strain_type": "Indica"
    },
    {
        "id": "89cf9378-0b11-43a4-b287-e28835ee7528",
        "initial_consumption_type": "Flower",
        "value": "Green Candy",
        "strain_type": "Sativa"
    },
    {
        "id": "46feeb62-5045-46a2-8582-092527e79636",
        "initial_consumption_type": "Flower",
        "value": "Green Crack",
        "strain_type": "Sativa"
    },
    {
        "id": "205e9992-83d2-4c8f-9f1f-ea55be8df0c7",
        "initial_consumption_type": "Flower",
        "value": "Green Crack Extreme",
        "strain_type": "Sativa"
    },
    {
        "id": "eecb9809-7fc4-474b-8114-ad3e6f21df42",
        "initial_consumption_type": "Flower",
        "value": "Green Door Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "05fd4253-f422-431b-94fd-9b8d3add054b",
        "initial_consumption_type": "Flower",
        "value": "Green Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "7ffb2f5f-5ead-4f80-8721-7da0a2ee4aeb",
        "initial_consumption_type": "Flower",
        "value": "Green Goblin",
        "strain_type": "Sativa"
    },
    {
        "id": "beff040a-df9c-4267-a3de-ccafe7e4ce67",
        "initial_consumption_type": "Flower",
        "value": "Green Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "fdd73a50-4b54-4c36-b4da-2acbe94014b2",
        "initial_consumption_type": "Flower",
        "value": "Green Hornet",
        "strain_type": "Hybrid"
    },
    {
        "id": "8cbf5f79-8b50-4ddd-986b-1262d58026e7",
        "initial_consumption_type": "Flower",
        "value": "Green Kush",
        "strain_type": "Indica"
    },
    {
        "id": "cd3ca46f-e4a6-4ca6-87a1-f45867dd2f85",
        "initial_consumption_type": "Flower",
        "value": "Green Monster",
        "strain_type": "Hybrid"
    },
    {
        "id": "604f1f22-9337-41cc-bf7d-5dc74b3ce0d0",
        "initial_consumption_type": "Flower",
        "value": "Green Poison",
        "strain_type": "Hybrid"
    },
    {
        "id": "265f5795-d440-45c6-b630-db481254e451",
        "initial_consumption_type": "Flower",
        "value": "Green Queen",
        "strain_type": "Hybrid"
    },
    {
        "id": "695a748d-010e-4a3a-ba1c-551701f64c98",
        "initial_consumption_type": "Flower",
        "value": "Green Ribbon",
        "strain_type": "Hybrid"
    },
    {
        "id": "f84ad7da-40f9-4ba2-ae88-e70e270d2211",
        "initial_consumption_type": "Flower",
        "value": "Guava Chem",
        "strain_type": "Hybrid"
    },
    {
        "id": "b121fdc8-eabe-473c-88d9-f2676f8dcad9",
        "initial_consumption_type": "Flower",
        "value": "Guava Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "4aaaaa8e-c5bf-4383-a4af-753bce7def7c",
        "initial_consumption_type": "Flower",
        "value": "Guido Kush",
        "strain_type": "Indica"
    },
    {
        "id": "12719e13-a738-4724-89c6-d9645ee25076",
        "initial_consumption_type": "Flower",
        "value": "Gumbo",
        "strain_type": "Indica"
    },
    {
        "id": "b9c246b0-1ccb-476e-ae8d-b86c1dd79878",
        "initial_consumption_type": "Flower",
        "value": "Harlequin",
        "strain_type": "Hybrid"
    },
    {
        "id": "66b2f9af-fcf2-40bf-adc7-df85ad9a8950",
        "initial_consumption_type": "Flower",
        "value": "Harvard Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "122456fb-599e-488a-a5c7-f66e62e53be0",
        "initial_consumption_type": "Flower",
        "value": "Hash Dawg",
        "strain_type": "Hybrid"
    },
    {
        "id": "c11f0f8f-098e-48e9-ab59-3fd91d2cbee2",
        "initial_consumption_type": "Flower",
        "value": "Hash Plant",
        "strain_type": "Indica"
    },
    {
        "id": "d263c4c8-44e0-4416-93fd-2890fcace77e",
        "initial_consumption_type": "Flower",
        "value": "Hashberry",
        "strain_type": "Indica"
    },
    {
        "id": "d81faaee-6132-495a-a65d-3a085dbfaa54",
        "initial_consumption_type": "Flower",
        "value": "Hashplant Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "cb28d164-87a6-4f88-8de9-e16064c60ffb",
        "initial_consumption_type": "Flower",
        "value": "Hawaii Gold",
        "strain_type": "Hybrid"
    },
    {
        "id": "ad08e869-41f5-4324-9166-177006e2ca24",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian",
        "strain_type": "Sativa"
    },
    {
        "id": "3366d13d-d41d-4116-bd9b-9d3b983b8f86",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Big Bud",
        "strain_type": "Hybrid"
    },
    {
        "id": "a90d1b41-e7ba-4d6a-b57f-95cd5cd44c02",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Delight",
        "strain_type": "Indica"
    },
    {
        "id": "219de9ba-06f8-4d51-8fcf-d31d1446b139",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "17abe2b9-17dd-4005-b6bb-f58288cbe36c",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Fire",
        "strain_type": "Hybrid"
    },
    {
        "id": "5eca825d-0d28-4fb7-953b-a8f03fa05307",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Gold",
        "strain_type": "Sativa"
    },
    {
        "id": "0aefa5ce-ef82-48da-b1d1-318f1ec2d97c",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "a00c39c1-6bcd-4b26-80f7-7e39131478c1",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Punch",
        "strain_type": "Hybrid"
    },
    {
        "id": "65c7d366-a4c1-452c-9849-5f6559db4184",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Sativa",
        "strain_type": "Sativa"
    },
    {
        "id": "cb44d858-49c0-493b-870f-f1bd69eb44e2",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "fbe7084e-128d-446a-9bc3-3d2ed93145b2",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Snow",
        "strain_type": "Sativa"
    },
    {
        "id": "4f282ead-1aa1-4fdf-8c5d-a315fd522fc9",
        "initial_consumption_type": "Flower",
        "value": "Hawaiian Thunder Fuck",
        "strain_type": "Hybrid"
    },
    {
        "id": "8c216f72-e50b-456f-9f3c-676454b05de9",
        "initial_consumption_type": "Flower",
        "value": "Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "15051112-9496-4e04-854d-1670bdb7c813",
        "initial_consumption_type": "Flower",
        "value": "Head Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "558a6dfa-b1a0-4f7a-8379-dda041906082",
        "initial_consumption_type": "Flower",
        "value": "Headband",
        "strain_type": "Hybrid"
    },
    {
        "id": "0fdae771-1bb8-459e-9d3b-12fc67cbe03b",
        "initial_consumption_type": "Flower",
        "value": "Headbanger",
        "strain_type": "Hybrid"
    },
    {
        "id": "7d587baf-0361-4949-a57f-3fceda84ad8e",
        "initial_consumption_type": "Flower",
        "value": "Headcheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "3b5de6c2-9093-45e2-82a8-54712c65cc9d",
        "initial_consumption_type": "Flower",
        "value": "Heavy Duty Fruity",
        "strain_type": "Hybrid"
    },
    {
        "id": "04c5ef0e-ae4b-4393-a545-ff0e7c92ada4",
        "initial_consumption_type": "Flower",
        "value": "Hempstar",
        "strain_type": "Sativa"
    },
    {
        "id": "a2180746-1e39-4467-a36d-42a6b47e26f5",
        "initial_consumption_type": "Flower",
        "value": "Herijuana",
        "strain_type": "Hybrid"
    },
    {
        "id": "083fc1ad-9d4a-4dea-a91d-3eea36ebdb19",
        "initial_consumption_type": "Flower",
        "value": "Herojuana",
        "strain_type": "Indica"
    },
    {
        "id": "92c4a40f-2afe-46f1-8d8e-2f580a662d99",
        "initial_consumption_type": "Flower",
        "value": "High Mids",
        "strain_type": "Sativa"
    },
    {
        "id": "fc242d2b-6f66-419e-90da-f199e684bdca",
        "initial_consumption_type": "Flower",
        "value": "Himalayan Gold",
        "strain_type": "Hybrid"
    },
    {
        "id": "a94b864d-02da-4c86-a229-043fe228b8e2",
        "initial_consumption_type": "Flower",
        "value": "Hindu Kush",
        "strain_type": "Indica"
    },
    {
        "id": "6e9145e8-b9d7-4bfb-8aa3-bf8d2e994d91",
        "initial_consumption_type": "Flower",
        "value": "Hindu Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "873fef21-a5c0-4621-92b7-349c19a5e487",
        "initial_consumption_type": "Flower",
        "value": "Hippie Crippler",
        "strain_type": "Hybrid"
    },
    {
        "id": "2e100bfa-61d1-4149-9a1d-05bcb80a0a39",
        "initial_consumption_type": "Flower",
        "value": "Hog",
        "strain_type": "Indica"
    },
    {
        "id": "51b0fdfc-9812-4bb7-94e0-bd690af3664f",
        "initial_consumption_type": "Flower",
        "value": "Hog’s Breath",
        "strain_type": "Indica"
    },
    {
        "id": "8ff6b97a-6bb2-4624-81c0-3d80afd6de3f",
        "initial_consumption_type": "Flower",
        "value": "Hollands Hope",
        "strain_type": "Indica"
    },
    {
        "id": "54a75d28-091e-4d06-b22b-31eac8b8f948",
        "initial_consumption_type": "Flower",
        "value": "Holy Ghost",
        "strain_type": "Hybrid"
    },
    {
        "id": "da9fcee8-3b1b-49bb-93ee-dce920f191d0",
        "initial_consumption_type": "Flower",
        "value": "Holy Grail Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "1bbdda41-14d1-49c2-b46f-55a3200a4f4a",
        "initial_consumption_type": "Flower",
        "value": "Hong Kong",
        "strain_type": "Hybrid"
    },
    {
        "id": "12937982-3386-4e1e-b20c-db0f7635af01",
        "initial_consumption_type": "Flower",
        "value": "Huckleberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "2154530b-4c55-45fb-9e76-b87c3c6b877a",
        "initial_consumption_type": "Flower",
        "value": "Humboldt",
        "strain_type": "Hybrid"
    },
    {
        "id": "27f79293-7fa0-48ca-8a5d-b36624d126da",
        "initial_consumption_type": "Flower",
        "value": "Hydro Green Crack",
        "strain_type": "Sativa"
    },
    {
        "id": "011ff006-65c8-4312-b844-3e95fa1ffb66",
        "initial_consumption_type": "Flower",
        "value": "Ice",
        "strain_type": "Hybrid"
    },
    {
        "id": "50321c68-0191-4dbe-a3e7-d4b0ae33a691",
        "initial_consumption_type": "Flower",
        "value": "Ice Cream",
        "strain_type": "Hybrid"
    },
    {
        "id": "77670ac9-8989-436b-87f0-a287abf07451",
        "initial_consumption_type": "Flower",
        "value": "Ice Queen",
        "strain_type": "Sativa"
    },
    {
        "id": "d8824874-3f94-494d-9931-42f17613dfa8",
        "initial_consumption_type": "Flower",
        "value": "Incrediberry",
        "strain_type": "Indica"
    },
    {
        "id": "6bfa1143-055e-4ba4-bc7b-97cb929699fc",
        "initial_consumption_type": "Flower",
        "value": "Ingrid",
        "strain_type": "Indica"
    },
    {
        "id": "6c6d2d44-8060-41e4-afd7-f0362bd191c7",
        "initial_consumption_type": "Flower",
        "value": "Irene Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "2034e211-6f7f-4969-b474-8f3d04872d34",
        "initial_consumption_type": "Flower",
        "value": "Island Maui Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "9dc572d8-4d35-421f-8714-6c98f3c85f6d",
        "initial_consumption_type": "Flower",
        "value": "Island Sweet Skunk",
        "strain_type": "Sativa"
    },
    {
        "id": "3e5cb41b-9534-46d5-8bb1-59f60e4c8695",
        "initial_consumption_type": "Flower",
        "value": "Ivory Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "3e9f677d-3e0f-4c91-878d-42f1fc1bb138",
        "initial_consumption_type": "Flower",
        "value": "J-27",
        "strain_type": "Sativa"
    },
    {
        "id": "7a4da064-f769-4b98-9ae4-220fce8343a4",
        "initial_consumption_type": "Flower",
        "value": "J1",
        "strain_type": "Hybrid"
    },
    {
        "id": "4c586483-34fb-40ca-a5ad-cc47d5c909a6",
        "initial_consumption_type": "Flower",
        "value": "Jack Flash",
        "strain_type": "Hybrid"
    },
    {
        "id": "e49c6c7d-2d19-4632-a6da-d495ded5374d",
        "initial_consumption_type": "Flower",
        "value": "Jack Frost",
        "strain_type": "Hybrid"
    },
    {
        "id": "f441989e-a5cc-44ef-a977-055a6236b879",
        "initial_consumption_type": "Flower",
        "value": "Jack Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "f4d2040b-1573-4901-8d94-9f82cf75ca03",
        "initial_consumption_type": "Flower",
        "value": "Jack Herer",
        "strain_type": "Sativa"
    },
    {
        "id": "f36dc55c-1bec-4aa6-8072-e6a208c64dce",
        "initial_consumption_type": "Flower",
        "value": "Jack Kevorkian",
        "strain_type": "Hybrid"
    },
    {
        "id": "e9c67819-cc9b-47fb-ba7c-bda89bbdc156",
        "initial_consumption_type": "Flower",
        "value": "Jack Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "5fcd0b42-bd12-461d-b00c-cbef93c608b9",
        "initial_consumption_type": "Flower",
        "value": "Jack the Ripper",
        "strain_type": "Hybrid"
    },
    {
        "id": "b6242b37-18f7-445e-a231-697339d9278c",
        "initial_consumption_type": "Flower",
        "value": "Jack Widow",
        "strain_type": "Hybrid"
    },
    {
        "id": "6ac11936-616a-4ccd-bda7-efebb4156534",
        "initial_consumption_type": "Flower",
        "value": "Jack’s Cleaner",
        "strain_type": "Hybrid"
    },
    {
        "id": "498e49c8-e700-47e7-8abb-d1b2f3e58f3c",
        "initial_consumption_type": "Flower",
        "value": "Jagermeister",
        "strain_type": "Indica"
    },
    {
        "id": "54c33a0c-9607-4787-bfac-84a08da41f0b",
        "initial_consumption_type": "Flower",
        "value": "Jah Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "d11598eb-76ef-40ec-b6f6-5ec64a683349",
        "initial_consumption_type": "Flower",
        "value": "Jamaican Pearl",
        "strain_type": "Sativa"
    },
    {
        "id": "1850d43a-3bce-433f-9d48-04c13bcbbed6",
        "initial_consumption_type": "Flower",
        "value": "Jane Doe",
        "strain_type": "Hybrid"
    },
    {
        "id": "f24230d7-30a5-4923-89cc-6f5e081e6321",
        "initial_consumption_type": "Flower",
        "value": "Jasmin",
        "strain_type": "Hybrid"
    },
    {
        "id": "33f5283d-b19f-4951-bccb-ce82fffeac8b",
        "initial_consumption_type": "Flower",
        "value": "Jean Guy",
        "strain_type": "Sativa"
    },
    {
        "id": "d19e00f9-22f6-423d-b124-86857320b7d2",
        "initial_consumption_type": "Flower",
        "value": "Jesus",
        "strain_type": "Hybrid"
    },
    {
        "id": "77b7ad35-d0c6-4e8f-b1a9-023730fd3c89",
        "initial_consumption_type": "Flower",
        "value": "Jesus OG",
        "strain_type": "Indica"
    },
    {
        "id": "19042037-ce47-4277-affc-ba16723db942",
        "initial_consumption_type": "Flower",
        "value": "Jillybean",
        "strain_type": "Hybrid"
    },
    {
        "id": "ebecf483-8930-412e-ac07-354b7d6c8f2d",
        "initial_consumption_type": "Flower",
        "value": "Jimi Hendrix",
        "strain_type": "Sativa"
    },
    {
        "id": "e663f13c-274a-492a-8acf-ecca4528c19f",
        "initial_consumption_type": "Flower",
        "value": "Jock Horror",
        "strain_type": "Sativa"
    },
    {
        "id": "c3917643-4017-4239-857e-6cc930e69eb0",
        "initial_consumption_type": "Flower",
        "value": "Johnny’s Tonic",
        "strain_type": "Sativa"
    },
    {
        "id": "7a6ae1a5-0f60-4886-887c-903bc2f2d931",
        "initial_consumption_type": "Flower",
        "value": "Jorees Diamond",
        "strain_type": "Sativa"
    },
    {
        "id": "54c142bd-680e-44da-b556-9960d4de3312",
        "initial_consumption_type": "Flower",
        "value": "Jorge’s Diamonds #1",
        "strain_type": "Hybrid"
    },
    {
        "id": "985597a0-3702-4311-8d39-ea66cc7922e6",
        "initial_consumption_type": "Flower",
        "value": "Juicy Fruit",
        "strain_type": "Hybrid"
    },
    {
        "id": "14f6da5e-d3e1-44a5-bd76-22ef283e78d3",
        "initial_consumption_type": "Flower",
        "value": "Juliet",
        "strain_type": "Hybrid"
    },
    {
        "id": "247b4fae-323c-4d3e-8d37-05e22b7fc1af",
        "initial_consumption_type": "Flower",
        "value": "Julius Caesar",
        "strain_type": "Hybrid"
    },
    {
        "id": "1fc3ad23-8fe5-4c89-a94f-3d340386dfb1",
        "initial_consumption_type": "Flower",
        "value": "Jupiter Kush",
        "strain_type": "Indica"
    },
    {
        "id": "17c6a4b9-cf1c-4f76-a73f-58e38125268e",
        "initial_consumption_type": "Flower",
        "value": "Jupiter OG",
        "strain_type": "Indica"
    },
    {
        "id": "0a244b2f-6346-4eee-9c7f-0ab6dd911876",
        "initial_consumption_type": "Flower",
        "value": "Jurassic Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "de2c00f8-6f2d-43d8-bbf2-eb2cf728e735",
        "initial_consumption_type": "Flower",
        "value": "K Train",
        "strain_type": "Indica"
    },
    {
        "id": "a204c234-d19d-4bbb-95f6-c36f448831bb",
        "initial_consumption_type": "Flower",
        "value": "K.O Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "c69e6e4d-83bc-421e-af2d-59d13c7824cb",
        "initial_consumption_type": "Flower",
        "value": "Kaboom",
        "strain_type": "Sativa"
    },
    {
        "id": "5c5fc6ee-a036-47e9-b3d6-2b32e31afb6c",
        "initial_consumption_type": "Flower",
        "value": "Kahuna",
        "strain_type": "Hybrid"
    },
    {
        "id": "c274e821-fd19-4e96-a564-0da974fa3010",
        "initial_consumption_type": "Flower",
        "value": "Kali Mist",
        "strain_type": "Sativa"
    },
    {
        "id": "46c15728-7b6e-4b6f-b2de-dcdef0994217",
        "initial_consumption_type": "Flower",
        "value": "Kandy Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "33484525-45b4-4253-a93a-da7fb9b68105",
        "initial_consumption_type": "Flower",
        "value": "Kashmir",
        "strain_type": "Hybrid"
    },
    {
        "id": "7888f972-e5d9-4ea3-8cf4-dd438b312433",
        "initial_consumption_type": "Flower",
        "value": "Kentucky Durban",
        "strain_type": "Sativa"
    },
    {
        "id": "cd862c17-fb59-400d-b980-8884aa0d7cec",
        "initial_consumption_type": "Flower",
        "value": "Key Lime Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "bbab0c4b-bcc3-45a4-a826-b04c430aab75",
        "initial_consumption_type": "Flower",
        "value": "Key Lime Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "353afa20-0560-412f-b367-f0ae60afcfbd",
        "initial_consumption_type": "Flower",
        "value": "Khola",
        "strain_type": "Hybrid"
    },
    {
        "id": "6c756c4d-9cad-42cb-abcf-f6dc5c6e54d8",
        "initial_consumption_type": "Flower",
        "value": "Killa Crip Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "3f2f365b-f805-4efd-99d7-5780f98dfc9e",
        "initial_consumption_type": "Flower",
        "value": "Killer Chem #3",
        "strain_type": "Hybrid"
    },
    {
        "id": "deb5ec60-2601-4785-a36a-82abc34ce2b0",
        "initial_consumption_type": "Flower",
        "value": "Killer Queen",
        "strain_type": "Hybrid"
    },
    {
        "id": "83670731-8f07-44db-8c6c-298a21ed7a53",
        "initial_consumption_type": "Flower",
        "value": "Killing Fields",
        "strain_type": "Sativa"
    },
    {
        "id": "bd99b3e0-e49c-4727-a518-90cbde9602cf",
        "initial_consumption_type": "Flower",
        "value": "Kimbo Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "49e42f27-27a7-4dee-979f-946a9d279205",
        "initial_consumption_type": "Flower",
        "value": "King Kong",
        "strain_type": "Hybrid"
    },
    {
        "id": "113cd3eb-5a7c-4ab8-bc54-01dea5deb4db",
        "initial_consumption_type": "Flower",
        "value": "King Kush",
        "strain_type": "Indica"
    },
    {
        "id": "ac51443a-1a9c-4052-9279-aac1388472b0",
        "initial_consumption_type": "Flower",
        "value": "King Louis",
        "strain_type": "Indica"
    },
    {
        "id": "5feebc17-c560-44fc-b225-5f626a1a489a",
        "initial_consumption_type": "Flower",
        "value": "King’s Bread",
        "strain_type": "Sativa"
    },
    {
        "id": "177671df-0670-4242-9b6a-5ed04d690094",
        "initial_consumption_type": "Flower",
        "value": "Knightrider Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "7faf90ed-6207-4eee-b728-01988e29496f",
        "initial_consumption_type": "Flower",
        "value": "Knock Out",
        "strain_type": "Sativa"
    },
    {
        "id": "839bdcc5-009b-427e-84c4-00577fcc5115",
        "initial_consumption_type": "Flower",
        "value": "Kosher Kush",
        "strain_type": "Indica"
    },
    {
        "id": "28e9f041-c78d-44b0-aeb6-2c0490b22179",
        "initial_consumption_type": "Flower",
        "value": "Kryptonite",
        "strain_type": "Indica"
    },
    {
        "id": "b0a5c78c-94e3-4938-8e6c-e7019042a7e6",
        "initial_consumption_type": "Flower",
        "value": "Kush",
        "strain_type": "Indica"
    },
    {
        "id": "0282148c-e1e5-4840-b480-e3ddc5805fbb",
        "initial_consumption_type": "Flower",
        "value": "Kush Berry",
        "strain_type": "Indica"
    },
    {
        "id": "e36bad29-7b52-4508-b162-ef7d7d500ba3",
        "initial_consumption_type": "Flower",
        "value": "Kushage",
        "strain_type": "Hybrid"
    },
    {
        "id": "9bfa91d5-573e-4f6a-93f8-db84f218cad8",
        "initial_consumption_type": "Flower",
        "value": "Kushashima",
        "strain_type": "Hybrid"
    },
    {
        "id": "0abca7f0-f341-428d-9296-a74283209608",
        "initial_consumption_type": "Flower",
        "value": "Kushberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "209bbf58-463c-4b1c-9a8c-732e7d24228a",
        "initial_consumption_type": "Flower",
        "value": "LA Confidential",
        "strain_type": "Indica"
    },
    {
        "id": "b8cd091b-5031-4c0c-afbe-87eba0c6387c",
        "initial_consumption_type": "Flower",
        "value": "LA Jack",
        "strain_type": "Hybrid"
    },
    {
        "id": "44ae7a02-4ec9-4a4d-b9f9-2d970477d4ce",
        "initial_consumption_type": "Flower",
        "value": "LA OG",
        "strain_type": "Indica"
    },
    {
        "id": "806e77bf-8cd8-4194-8b15-2c66392d8024",
        "initial_consumption_type": "Flower",
        "value": "LA Woman",
        "strain_type": "Hybrid"
    },
    {
        "id": "d6647e14-76d1-4dad-9387-25ea67d7baa7",
        "initial_consumption_type": "Flower",
        "value": "Lambo OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "dfee9488-0824-4609-8ce8-7cbdf74ab8d5",
        "initial_consumption_type": "Flower",
        "value": "Larry OG",
        "strain_type": "Indica"
    },
    {
        "id": "c025a4e0-489c-4a4c-aa14-651b079d4099",
        "initial_consumption_type": "Flower",
        "value": "Laughing Buddha",
        "strain_type": "Sativa"
    },
    {
        "id": "814d14c7-b1be-4943-9e6e-054304bb139b",
        "initial_consumption_type": "Flower",
        "value": "Lavender",
        "strain_type": "Hybrid"
    },
    {
        "id": "2a3e0a43-7888-4eb3-b7e7-c5c60b43cce5",
        "initial_consumption_type": "Flower",
        "value": "Lavender Hash",
        "strain_type": "Indica"
    },
    {
        "id": "8eb029a2-0c8a-4929-b20d-930586e05b13",
        "initial_consumption_type": "Flower",
        "value": "Lavender Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "fc170d3e-d624-40ee-9219-e2da611ffe87",
        "initial_consumption_type": "Flower",
        "value": "Lavender Kush",
        "strain_type": "Indica"
    },
    {
        "id": "b105e94d-5770-4d2c-afe8-e302a27b9bb1",
        "initial_consumption_type": "Flower",
        "value": "Lemon Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "0ae050af-b76d-4c9d-bfe4-90406a545966",
        "initial_consumption_type": "Flower",
        "value": "Lemon Drop",
        "strain_type": "Hybrid"
    },
    {
        "id": "c3145bc7-0979-4ef0-b324-4ade4e8b4867",
        "initial_consumption_type": "Flower",
        "value": "Lemon G",
        "strain_type": "Sativa"
    },
    {
        "id": "bd5a66f7-ab10-4fd5-996f-7c864da70fc0",
        "initial_consumption_type": "Flower",
        "value": "Lemon Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "ce6f3fef-1912-4bb2-9e53-d6c8b33e1d48",
        "initial_consumption_type": "Flower",
        "value": "Lemon Jack",
        "strain_type": "Sativa"
    },
    {
        "id": "2e7e03c1-3f0d-452b-83fe-7dfdfccc9dba",
        "initial_consumption_type": "Flower",
        "value": "Lemon Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "f785aef5-d7a6-4b8d-973e-1a240da8cf70",
        "initial_consumption_type": "Flower",
        "value": "Lemon Lime Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "a6e7ea9d-4c48-4ac0-b759-14895c3cb274",
        "initial_consumption_type": "Flower",
        "value": "Lemon Mazar",
        "strain_type": "Indica"
    },
    {
        "id": "16af0fe6-13cd-4008-954d-09123e979886",
        "initial_consumption_type": "Flower",
        "value": "Lemon OG",
        "strain_type": "Indica"
    },
    {
        "id": "558b6b38-0603-4ef1-a1f0-781a059507e4",
        "initial_consumption_type": "Flower",
        "value": "Lemon Sativa",
        "strain_type": "Sativa"
    },
    {
        "id": "e9a250ce-faca-4f32-ad21-5bed2a8058c2",
        "initial_consumption_type": "Flower",
        "value": "Lemon Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "9a184253-bcc9-4b9a-a952-dd0fe13b748b",
        "initial_consumption_type": "Flower",
        "value": "Lemon Skunk x Island Sweet Skunk",
        "strain_type": "Sativa"
    },
    {
        "id": "c79b4c8a-f80b-49cf-a2d9-0bae316a9982",
        "initial_consumption_type": "Flower",
        "value": "Lemon Skunk X Maui Wowie",
        "strain_type": "Indica"
    },
    {
        "id": "670fa075-78be-499e-832a-d46b46aa94e3",
        "initial_consumption_type": "Flower",
        "value": "Lemon Thai",
        "strain_type": "Sativa"
    },
    {
        "id": "a332578a-dd5a-4643-9438-374994223696",
        "initial_consumption_type": "Flower",
        "value": "Lemon Wreck",
        "strain_type": "Hybrid"
    },
    {
        "id": "e9abddc3-2040-4f0b-a117-2d703c3fb378",
        "initial_consumption_type": "Flower",
        "value": "Lethal Purple",
        "strain_type": "Hybrid"
    },
    {
        "id": "a81b63a5-f60a-48aa-b213-1527612662cc",
        "initial_consumption_type": "Flower",
        "value": "Liberty Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "800a468e-0347-4cc7-8547-774883e50a62",
        "initial_consumption_type": "Flower",
        "value": "Lifesaver",
        "strain_type": "Hybrid"
    },
    {
        "id": "d4da4ab7-2340-491b-9b9b-c0a0aea59eeb",
        "initial_consumption_type": "Flower",
        "value": "Lil Afghani",
        "strain_type": "Indica"
    },
    {
        "id": "af9f8fa4-9e50-4300-a8a0-c657184eae5c",
        "initial_consumption_type": "Flower",
        "value": "Lime Green Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "1ffe17b6-f02e-409a-a09f-ad4692d34a80",
        "initial_consumption_type": "Flower",
        "value": "Lions Gate",
        "strain_type": "Indica"
    },
    {
        "id": "a16f5295-a5d1-47fc-868a-177d36f5ef29",
        "initial_consumption_type": "Flower",
        "value": "Liquid Butter",
        "strain_type": "Indica"
    },
    {
        "id": "aae966c7-cbfb-4dbd-915d-a21ad6997b6c",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold CBD Vape Oil",
        "strain_type": "Hybrid"
    },
    {
        "id": "fc4eb778-8a9e-45c6-8628-da3e29e5f011",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen Blackberry Kush",
        "strain_type": "Indica"
    },
    {
        "id": "597eae30-04d0-4d15-91c7-ec8159fa8786",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen Blue Diamond",
        "strain_type": "Hybrid"
    },
    {
        "id": "bb87f18a-11a5-47e3-b10e-e6f759c8c110",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen Green Crack",
        "strain_type": "Sativa"
    },
    {
        "id": "bd6b16e0-a9fe-4a45-a0fc-5846ca6d33e3",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen Orange Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "55f143cf-6fc9-4de4-bc9e-0965501470aa",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen Pink Lemonade",
        "strain_type": "Hybrid"
    },
    {
        "id": "ed53cb73-bb29-4d38-9021-eb442b0a95ed",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen Purple Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "81ad8d98-682d-4027-9a60-0b306b2e9d3c",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen Red Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "4056cd36-3aa3-4f08-94bc-28fbec96c908",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen Silver Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "aed6610d-8f2c-4368-9bdb-c70e4e781c43",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen Super Silver Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "34d4bc82-34eb-4a2a-98b9-f5992f276acc",
        "initial_consumption_type": "Flower",
        "value": "Liquid Gold Vape Pen White Widow",
        "strain_type": "Hybrid"
    },
    {
        "id": "c539b533-732e-42d2-aa8a-49b0393abe3d",
        "initial_consumption_type": "Flower",
        "value": "Little Devil",
        "strain_type": "Hybrid"
    },
    {
        "id": "fdb4c580-2bc6-4eb9-8615-b773dfa5c126",
        "initial_consumption_type": "Flower",
        "value": "Loud",
        "strain_type": "Sativa"
    },
    {
        "id": "1278850b-1317-4a2e-a4b2-db9c6bc1f57f",
        "initial_consumption_type": "Flower",
        "value": "Loud Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "c6b1715c-5e83-4ceb-9410-30da9119cdbe",
        "initial_consumption_type": "Flower",
        "value": "Louis XIII",
        "strain_type": "Indica"
    },
    {
        "id": "66e4d471-6efe-4e4f-a0aa-ce6874b6bccd",
        "initial_consumption_type": "Flower",
        "value": "Louisiana Swamp Moss",
        "strain_type": "Indica"
    },
    {
        "id": "1b359e85-eab0-4aa6-ab0a-7693673bd5b4",
        "initial_consumption_type": "Flower",
        "value": "Lowryder",
        "strain_type": "Hybrid"
    },
    {
        "id": "5ef85ea7-9951-4807-aece-9f7aeb84b6cf",
        "initial_consumption_type": "Flower",
        "value": "LSD",
        "strain_type": "Hybrid"
    },
    {
        "id": "1e013988-876c-48e1-91be-21b78c322037",
        "initial_consumption_type": "Flower",
        "value": "Lucky Charms",
        "strain_type": "Indica"
    },
    {
        "id": "e0fe4c04-e499-4ac7-8de9-dd3b1a6b93ff",
        "initial_consumption_type": "Flower",
        "value": "Lucky Seven",
        "strain_type": "Hybrid"
    },
    {
        "id": "ea0222d0-d5a6-4a07-8c24-170c933e6627",
        "initial_consumption_type": "Flower",
        "value": "LVPK",
        "strain_type": "Hybrid"
    },
    {
        "id": "ba7cc8ce-115c-4828-b22c-87497ee0c556",
        "initial_consumption_type": "Flower",
        "value": "M-39",
        "strain_type": "Hybrid"
    },
    {
        "id": "48e524e7-0503-4175-bb4d-9f854e28d6d9",
        "initial_consumption_type": "Flower",
        "value": "Mad Dawg",
        "strain_type": "Hybrid"
    },
    {
        "id": "7bf2593d-5c97-4711-8c3c-9d0c214f1444",
        "initial_consumption_type": "Flower",
        "value": "Madagascar",
        "strain_type": "Indica"
    },
    {
        "id": "a053a27f-0d05-4af3-baae-2679851ba36b",
        "initial_consumption_type": "Flower",
        "value": "Mako Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "2f8ee434-f573-4bfa-bf0b-abd344b7a9e3",
        "initial_consumption_type": "Flower",
        "value": "Malawi",
        "strain_type": "Sativa"
    },
    {
        "id": "4b6b9c0c-569f-4374-872e-1c0b238ebba8",
        "initial_consumption_type": "Flower",
        "value": "Mandala #1",
        "strain_type": "Hybrid"
    },
    {
        "id": "dcbe98f1-1088-4ebb-8ba0-22c0a0fbde24",
        "initial_consumption_type": "Flower",
        "value": "Mango",
        "strain_type": "Indica"
    },
    {
        "id": "44d992bb-fddc-4223-bb7a-4cced9774e39",
        "initial_consumption_type": "Flower",
        "value": "Mango Dream",
        "strain_type": "Sativa"
    },
    {
        "id": "ad23a7db-c431-49fa-8488-29551def986e",
        "initial_consumption_type": "Flower",
        "value": "Mango Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "2087a139-da9d-4d1a-960f-6bbf0397a7de",
        "initial_consumption_type": "Flower",
        "value": "Manitoba Poison",
        "strain_type": "Hybrid"
    },
    {
        "id": "0469b3ce-3635-4d10-9a05-c6d251794f4e",
        "initial_consumption_type": "Flower",
        "value": "Maple Leaf Indica",
        "strain_type": "Indica"
    },
    {
        "id": "e70ba381-f6cd-4b19-8fb1-63b04596d3a5",
        "initial_consumption_type": "Flower",
        "value": "Marilyn Monroe",
        "strain_type": "Hybrid"
    },
    {
        "id": "d7d2189e-595d-4a53-9294-c97d45a6276e",
        "initial_consumption_type": "Flower",
        "value": "Mars OG",
        "strain_type": "Indica"
    },
    {
        "id": "f9e7d7d4-f4c0-479f-9d8e-19ec29f3542d",
        "initial_consumption_type": "Flower",
        "value": "Martian Mean Green",
        "strain_type": "Hybrid"
    },
    {
        "id": "2aad02f9-1d5d-4b1a-85a2-64fa262c0425",
        "initial_consumption_type": "Flower",
        "value": "Master Bubba",
        "strain_type": "Indica"
    },
    {
        "id": "cbc1499b-5e9f-40e2-a153-44223098609c",
        "initial_consumption_type": "Flower",
        "value": "Master Jedi",
        "strain_type": "Indica"
    },
    {
        "id": "216f57b9-dea5-4cda-8462-d23b537fc4d2",
        "initial_consumption_type": "Flower",
        "value": "Master Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "db638f49-279f-41a8-a5ad-5350f89f6d19",
        "initial_consumption_type": "Flower",
        "value": "Master Kush Diesel",
        "strain_type": "Indica"
    },
    {
        "id": "4793068b-8c1d-400b-8dcf-0d91d6e1697e",
        "initial_consumption_type": "Flower",
        "value": "Master x Blackberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "43cedd9e-6f6d-40e0-9ec6-67818f4e6dc6",
        "initial_consumption_type": "Flower",
        "value": "Master Yoda",
        "strain_type": "Hybrid"
    },
    {
        "id": "fb1f07a6-a041-4f2c-9464-abbf873cef8b",
        "initial_consumption_type": "Flower",
        "value": "Matsu",
        "strain_type": "Indica"
    },
    {
        "id": "c3f319d8-3ffd-4284-ab0c-f2f6db0aeb98",
        "initial_consumption_type": "Flower",
        "value": "Maui",
        "strain_type": "Sativa"
    },
    {
        "id": "cc4fb512-aae0-49c7-bea8-17feac63beab",
        "initial_consumption_type": "Flower",
        "value": "Maui Berry",
        "strain_type": "Hybrid"
    },
    {
        "id": "62b21c4e-2300-42f3-a5f4-3d74990e9a7f",
        "initial_consumption_type": "Flower",
        "value": "Maui Waui",
        "strain_type": "Sativa"
    },
    {
        "id": "8b015e2b-ca4d-4deb-812b-516a5b29ec56",
        "initial_consumption_type": "Flower",
        "value": "Mazar I Sharif",
        "strain_type": "Indica"
    },
    {
        "id": "60481a82-ae0c-4c54-8294-73b87cbc8849",
        "initial_consumption_type": "",
        "value": "Medicated Dixie Roll",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "f164f772-a3e2-4c3e-abaa-9433c5a8974c",
        "initial_consumption_type": "Flower",
        "value": "Medicine Man",
        "strain_type": "Hybrid"
    },
    {
        "id": "479f38b2-7f19-4b97-822f-b055e092c2c2",
        "initial_consumption_type": "Flower",
        "value": "Mendocino Purps",
        "strain_type": "Hybrid"
    },
    {
        "id": "c4cc95ae-1831-4533-96ef-fa54edeebe97",
        "initial_consumption_type": "Flower",
        "value": "Mercury OG",
        "strain_type": "Indica"
    },
    {
        "id": "a1e5dcbf-2182-4b46-9fdc-d596ea14ed20",
        "initial_consumption_type": "Flower",
        "value": "Meroin",
        "strain_type": "Hybrid"
    },
    {
        "id": "9fa1cac9-fd40-4b95-9f1f-d1b0ce0e2cc5",
        "initial_consumption_type": "Flower",
        "value": "Mexican Sativa",
        "strain_type": "Hybrid"
    },
    {
        "id": "230c7acd-2071-41e4-89fa-2ee35565c912",
        "initial_consumption_type": "Flower",
        "value": "Midnight",
        "strain_type": "Hybrid"
    },
    {
        "id": "1e6aafb5-3539-44a3-b247-40f958e9cbcb",
        "initial_consumption_type": "Flower",
        "value": "Millennium",
        "strain_type": "Hybrid"
    },
    {
        "id": "adf92a0e-1671-4cb1-80ab-cca27b49896a",
        "initial_consumption_type": "Flower",
        "value": "Misty Kush",
        "strain_type": "Indica"
    },
    {
        "id": "1862a4b4-71ee-4977-9c61-90ef3783a7aa",
        "initial_consumption_type": "Flower",
        "value": "MK Ultra",
        "strain_type": "Indica"
    },
    {
        "id": "769bfdc2-800e-49dd-a814-e4ba4279e2a1",
        "initial_consumption_type": "Flower",
        "value": "Moby Dick",
        "strain_type": "Sativa"
    },
    {
        "id": "4d54bd8c-b922-4030-b07a-856c3a0885b7",
        "initial_consumption_type": "Flower",
        "value": "Mohan Ram",
        "strain_type": "Hybrid"
    },
    {
        "id": "28d9a19d-328a-4f70-8741-b5cb55bae1fa",
        "initial_consumption_type": "Flower",
        "value": "Moolah",
        "strain_type": "Hybrid"
    },
    {
        "id": "2c9fff40-5383-4718-8ff5-b6b4da4bdd35",
        "initial_consumption_type": "Flower",
        "value": "Moonlight OG Kush",
        "strain_type": "Indica"
    },
    {
        "id": "a868b322-1c32-4272-8e84-c7686509cc9e",
        "initial_consumption_type": "Flower",
        "value": "Morning Star",
        "strain_type": "Hybrid"
    },
    {
        "id": "c60729da-2673-492b-9a17-14e73c89ee1b",
        "initial_consumption_type": "Flower",
        "value": "Mossimo OG",
        "strain_type": "Indica"
    },
    {
        "id": "d129af7a-8f85-4665-bd7b-0e53b0922dbd",
        "initial_consumption_type": "Flower",
        "value": "Mr. Nice",
        "strain_type": "Hybrid"
    },
    {
        "id": "c6a9457b-798e-4bf6-b8a7-d7ea07f6c758",
        "initial_consumption_type": "Flower",
        "value": "Mr. Nice Guy",
        "strain_type": "Sativa"
    },
    {
        "id": "11711f76-e28d-4dde-a6fe-a9fa921b5229",
        "initial_consumption_type": "Flower",
        "value": "Nebula",
        "strain_type": "Hybrid"
    },
    {
        "id": "58c53609-ff5a-48be-bc36-c0e60421588a",
        "initial_consumption_type": "Flower",
        "value": "Neptune Kush",
        "strain_type": "Indica"
    },
    {
        "id": "05fab87e-cbb5-437b-ade1-a04ec9dc9bb3",
        "initial_consumption_type": "Flower",
        "value": "Neptune OG",
        "strain_type": "Indica"
    },
    {
        "id": "98038205-1a0b-49c8-a4a6-e4bd045b5058",
        "initial_consumption_type": "Flower",
        "value": "Neville’s Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "e280e050-057e-46d1-b970-a163570ec3ea",
        "initial_consumption_type": "Flower",
        "value": "New Blue Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "390f514b-cb5d-449b-a7be-23633e4f3322",
        "initial_consumption_type": "Flower",
        "value": "New Willies",
        "strain_type": "Hybrid"
    },
    {
        "id": "2fd80c13-08f3-419c-99e4-5e1f32172178",
        "initial_consumption_type": "Flower",
        "value": "Nexus OG",
        "strain_type": "Indica"
    },
    {
        "id": "ec0bb655-8c61-4093-93b6-6d87b5bdbf0e",
        "initial_consumption_type": "Flower",
        "value": "Nice Guy",
        "strain_type": "Hybrid"
    },
    {
        "id": "4aa7f5ba-880e-4346-9483-527da000e19d",
        "initial_consumption_type": "Flower",
        "value": "Night Train",
        "strain_type": "Hybrid"
    },
    {
        "id": "67e9dd38-5220-464d-afcc-3e6c24e0e178",
        "initial_consumption_type": "Flower",
        "value": "Ninja Turtle",
        "strain_type": "Hybrid"
    },
    {
        "id": "e41397fa-0b34-418c-9f3d-d093a67f3802",
        "initial_consumption_type": "Flower",
        "value": "NLX",
        "strain_type": "Hybrid"
    },
    {
        "id": "44aa4702-2e9e-4e6b-8b99-a960271298b6",
        "initial_consumption_type": "Flower",
        "value": "Nordle",
        "strain_type": "Indica"
    },
    {
        "id": "74fed345-2928-4b7e-821f-91cc895e737f",
        "initial_consumption_type": "Flower",
        "value": "Northen Lights #7",
        "strain_type": "Indica"
    },
    {
        "id": "eed78712-91dd-46d8-a7e7-23355eefc068",
        "initial_consumption_type": "Flower",
        "value": "Northern Lights",
        "strain_type": "Indica"
    },
    {
        "id": "57a6206a-e642-44cd-acc0-803b5aa9c2fa",
        "initial_consumption_type": "Flower",
        "value": "Northern Lights #5",
        "strain_type": "Hybrid"
    },
    {
        "id": "68307823-e4d6-400c-a7a8-57d039c16c93",
        "initial_consumption_type": "Flower",
        "value": "Northern Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "90b2d453-15d9-435a-a625-5f5c0fc29e73",
        "initial_consumption_type": "Flower",
        "value": "Northernberry",
        "strain_type": "Indica"
    },
    {
        "id": "d9bfa536-c4f6-4e3c-9239-5a44e02dfb37",
        "initial_consumption_type": "Flower",
        "value": "Nothern Lights x Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "81240780-eaf0-495e-93d8-0b126e0bc8be",
        "initial_consumption_type": "Flower",
        "value": "Nuggetry OG",
        "strain_type": "Indica"
    },
    {
        "id": "78bd5a40-f813-44c2-a8c9-6dda781fcea6",
        "initial_consumption_type": "Flower",
        "value": "NY Kush",
        "strain_type": "Indica"
    },
    {
        "id": "56f3142e-a50b-480b-b072-c25f4203941e",
        "initial_consumption_type": "Flower",
        "value": "NYC Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "d937730c-011e-45c5-8126-2c8116c57e5c",
        "initial_consumption_type": "Flower",
        "value": "NYC Sour Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "80a84b00-44fe-4ecb-80dd-766299309c70",
        "initial_consumption_type": "Flower",
        "value": "Obama Kush",
        "strain_type": "Indica"
    },
    {
        "id": "dfcfc6ff-b9ea-4675-b788-4bf2bd1e2008",
        "initial_consumption_type": "Flower",
        "value": "OCD",
        "strain_type": "Sativa"
    },
    {
        "id": "f19a6d5c-8f38-48d7-aca3-a101dcda5fd1",
        "initial_consumption_type": "Flower",
        "value": "Odyssey",
        "strain_type": "Indica"
    },
    {
        "id": "6a7bad6d-2414-4695-80d1-2230b05513f1",
        "initial_consumption_type": "Flower",
        "value": "OG",
        "strain_type": "Sativa"
    },
    {
        "id": "ea6b0b43-d7ba-4275-8746-04682475514f",
        "initial_consumption_type": "Flower",
        "value": "OG d",
        "strain_type": "Hybrid"
    },
    {
        "id": "e61946cb-a4a8-47e1-9f13-f747c683a4e3",
        "initial_consumption_type": "Flower",
        "value": "OG Diesel Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "4785c183-d866-4fb5-98b0-d7c2cfc5c844",
        "initial_consumption_type": "Flower",
        "value": "OG Eddy Lepp",
        "strain_type": "Indica"
    },
    {
        "id": "b3c4b8d9-ff8c-42e0-81db-d1fc73b7d476",
        "initial_consumption_type": "Flower",
        "value": "OG Headband",
        "strain_type": "Hybrid"
    },
    {
        "id": "296009cd-0186-4c7a-8c8b-d6906a1dd3bc",
        "initial_consumption_type": "Flower",
        "value": "OG j",
        "strain_type": "Hybrid"
    },
    {
        "id": "94128b59-0a8d-43e4-97f5-2d306e46b0fe",
        "initial_consumption_type": "Flower",
        "value": "OG Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "d87c7906-2dd5-40bf-b4eb-3e19228d0f97",
        "initial_consumption_type": "Flower",
        "value": "OG Mango",
        "strain_type": "Hybrid"
    },
    {
        "id": "c6c37b60-2955-4f56-aa9b-b68b58b3a486",
        "initial_consumption_type": "Flower",
        "value": "OG Michael Phelps",
        "strain_type": "Hybrid"
    },
    {
        "id": "b0c9c82c-88fd-48b9-92e1-0c02524e64d5",
        "initial_consumption_type": "Flower",
        "value": "OG Poison",
        "strain_type": "Hybrid"
    },
    {
        "id": "ea5a64ce-c0b5-4a78-b224-3cccae139d24",
        "initial_consumption_type": "Flower",
        "value": "OG Shark",
        "strain_type": "Hybrid"
    },
    {
        "id": "9ec7624a-62ab-4f35-af8c-e362c028df1b",
        "initial_consumption_type": "Flower",
        "value": "OG Wreck",
        "strain_type": "Hybrid"
    },
    {
        "id": "2b465780-e945-4ffd-a066-84b67137bb09",
        "initial_consumption_type": "Flower",
        "value": "OG- a",
        "strain_type": "Hybrid"
    },
    {
        "id": "f13a4119-e1dc-4594-8bc7-f0152fb72fef",
        "initial_consumption_type": "Flower",
        "value": "OG- b",
        "strain_type": "Hybrid"
    },
    {
        "id": "2f17abc2-5d35-4e19-b68c-b1b709ba1cc4",
        "initial_consumption_type": "Flower",
        "value": "OGiesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "d5a9198e-a870-41d4-b149-1819e4152826",
        "initial_consumption_type": "Flower",
        "value": "Ogre",
        "strain_type": "Indica"
    },
    {
        "id": "20d63913-211b-427e-befe-d957859c8cbb",
        "initial_consumption_type": "",
        "value": "Oil of Cannabis Lemonade Candy",
        "strain_type": "Edible StrainsEdible"
    },
    {
        "id": "1e4e8a42-34b7-424a-b972-5c01692b3a37",
        "initial_consumption_type": "Flower",
        "value": "Old Lyme Connecticut OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "c693b2df-2b1a-46cf-8686-fb7b3866f816",
        "initial_consumption_type": "Flower",
        "value": "Or",
        "strain_type": "Hybrid"
    },
    {
        "id": "1cc865cf-b6f2-4e7b-98e6-96e11e28d2a3",
        "initial_consumption_type": "Flower",
        "value": "Orange Bud",
        "strain_type": "Indica"
    },
    {
        "id": "0da45787-9912-4486-a3a3-829a56550b39",
        "initial_consumption_type": "Flower",
        "value": "Orange Cream",
        "strain_type": "Hybrid"
    },
    {
        "id": "94a3c945-6eb4-4060-bcf7-58500b891c2a",
        "initial_consumption_type": "Flower",
        "value": "Orange Crush",
        "strain_type": "Hybrid"
    },
    {
        "id": "1f8831be-67ce-40b8-92f8-a04b3974a161",
        "initial_consumption_type": "Flower",
        "value": "Orange Crush x Ice Cream",
        "strain_type": "Hybrid"
    },
    {
        "id": "07da9b73-b22c-4316-9f4b-f3f7b7f5dbf0",
        "initial_consumption_type": "Flower",
        "value": "Orange Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "3f25b581-92f6-4e55-99bb-ec2dc2913c46",
        "initial_consumption_type": "Flower",
        "value": "Orange Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "025d6d4e-db41-4788-b6f7-020a7e9fab38",
        "initial_consumption_type": "Flower",
        "value": "Orange Velvet",
        "strain_type": "Hybrid"
    },
    {
        "id": "be4122c9-ad27-4a09-b276-13d4d85ea5e5",
        "initial_consumption_type": "Flower",
        "value": "Orange Widow",
        "strain_type": "Sativa"
    },
    {
        "id": "c822140e-7230-40ee-8e65-c2b1adc24a85",
        "initial_consumption_type": "Flower",
        "value": "Organic Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "f4fb4a46-07ef-4907-8089-da807446e854",
        "initial_consumption_type": "Flower",
        "value": "Outer Space",
        "strain_type": "Sativa"
    },
    {
        "id": "00a7a590-fdf3-4719-bf64-9cf78e6cdc04",
        "initial_consumption_type": "Flower",
        "value": "P-91",
        "strain_type": "Hybrid"
    },
    {
        "id": "9921ed0b-bda5-4291-ba5a-26ee8346d02d",
        "initial_consumption_type": "Flower",
        "value": "Pakistan Chitral Kush",
        "strain_type": "Indica"
    },
    {
        "id": "54c168cd-41bd-47cd-9d72-e5aab7c78d6a",
        "initial_consumption_type": "Flower",
        "value": "Panama Red",
        "strain_type": "Sativa"
    },
    {
        "id": "1d19ad9d-4f8f-4981-8880-73f1bd56cf8f",
        "initial_consumption_type": "Flower",
        "value": "Pandora’s Box",
        "strain_type": "Sativa"
    },
    {
        "id": "ef789db8-7261-4c37-91b1-f6407351c866",
        "initial_consumption_type": "Flower",
        "value": "Papaya",
        "strain_type": "Hybrid"
    },
    {
        "id": "d5955a51-d2d0-47cb-a184-cb42cbce8f2e",
        "initial_consumption_type": "Flower",
        "value": "Paramedic",
        "strain_type": "Indica"
    },
    {
        "id": "d9ac6d50-9a3f-4fd1-8eac-6b97407b3626",
        "initial_consumption_type": "Flower",
        "value": "Paris OG",
        "strain_type": "Indica"
    },
    {
        "id": "779ea051-46d3-4176-8682-6608ea3925fa",
        "initial_consumption_type": "Flower",
        "value": "Parker Kush",
        "strain_type": "Indica"
    },
    {
        "id": "6bde98b5-fde2-4540-8d09-bad70a421be0",
        "initial_consumption_type": "Flower",
        "value": "Pennywise",
        "strain_type": "Indica"
    },
    {
        "id": "8a1394bb-d1ab-4468-ac37-332408dd021f",
        "initial_consumption_type": "Flower",
        "value": "Perma hash",
        "strain_type": "Indica"
    },
    {
        "id": "684ea3b2-7e9d-4ab0-a54b-d277f383bdb6",
        "initial_consumption_type": "Flower",
        "value": "Permafrost",
        "strain_type": "Hybrid"
    },
    {
        "id": "4e03365d-dff0-40c4-aaf8-07d7d3d15989",
        "initial_consumption_type": "Flower",
        "value": "Perplex",
        "strain_type": "Indica"
    },
    {
        "id": "7635f00d-0265-4a8e-aab1-fbc49013b17c",
        "initial_consumption_type": "Flower",
        "value": "Phoenix Sun",
        "strain_type": "Hybrid"
    },
    {
        "id": "335afc8d-0a3d-4826-8fea-3237807c1667",
        "initial_consumption_type": "Flower",
        "value": "Piezel",
        "strain_type": "Hybrid"
    },
    {
        "id": "a3196ad9-8a1f-4321-8c39-3c1da991b598",
        "initial_consumption_type": "Flower",
        "value": "Pineapple",
        "strain_type": "Hybrid"
    },
    {
        "id": "1c981d92-00a6-4a31-be21-88705c0484bd",
        "initial_consumption_type": "Flower",
        "value": "Pineapple Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "0bf17e71-029d-49ac-9419-05b8ec853a56",
        "initial_consumption_type": "Flower",
        "value": "Pineapple Express",
        "strain_type": "Hybrid"
    },
    {
        "id": "72f4e196-c7f1-416d-8a5e-82fcc7fa749b",
        "initial_consumption_type": "Flower",
        "value": "Pineapple Express 2013",
        "strain_type": "Sativa"
    },
    {
        "id": "99fad562-fc4c-4e2a-ad49-e111dbae37a1",
        "initial_consumption_type": "Flower",
        "value": "Pineapple Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "6abc8696-6608-4f1b-b8b1-588f970afbaf",
        "initial_consumption_type": "Flower",
        "value": "Pineapple Thai",
        "strain_type": "Indica"
    },
    {
        "id": "2c7056d6-046a-4c24-ba4c-171fb760a9c0",
        "initial_consumption_type": "Flower",
        "value": "Pineapple Trainwreck",
        "strain_type": "Sativa"
    },
    {
        "id": "0c75b36d-2f68-4d45-ac7e-2c825e18f684",
        "initial_consumption_type": "Flower",
        "value": "Pink Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "27ec1c6d-010a-411b-a2c5-758c19148b51",
        "initial_consumption_type": "Flower",
        "value": "Pink Lady",
        "strain_type": "Sativa"
    },
    {
        "id": "40e2ac1c-5c94-4dc5-a4b2-79adb43bf6a3",
        "initial_consumption_type": "Flower",
        "value": "Pink Pez",
        "strain_type": "Hybrid"
    },
    {
        "id": "e8778231-02d0-41de-971b-cdae24d4a088",
        "initial_consumption_type": "Flower",
        "value": "Pitbull",
        "strain_type": "Indica"
    },
    {
        "id": "0787a81a-2b12-4b36-8fc0-aaf68914f81c",
        "initial_consumption_type": "Flower",
        "value": "PK White Widow",
        "strain_type": "Hybrid"
    },
    {
        "id": "9a81b3b0-20d7-4e58-8f45-19453eec5e84",
        "initial_consumption_type": "Flower",
        "value": "Plane Crash",
        "strain_type": "Indica"
    },
    {
        "id": "59c0709a-bd21-4bb2-934b-77cf03edf409",
        "initial_consumption_type": "Flower",
        "value": "Platinum Bubba",
        "strain_type": "Indica"
    },
    {
        "id": "0bacb355-9387-4320-8b96-b10ec73a8dc4",
        "initial_consumption_type": "Flower",
        "value": "Platinum Bubba Kush",
        "strain_type": "Indica"
    },
    {
        "id": "d6bf475c-9d22-4863-a204-067c4f9a6538",
        "initial_consumption_type": "Flower",
        "value": "Platinum Ghost",
        "strain_type": "Hybrid"
    },
    {
        "id": "75610904-9527-4ee8-870a-21f3d8c2b03f",
        "initial_consumption_type": "Flower",
        "value": "Platinum Girl Scout Cookies",
        "strain_type": "Hybrid"
    },
    {
        "id": "e747c533-cc22-4a98-a646-985597620c84",
        "initial_consumption_type": "Flower",
        "value": "Platinum Kush",
        "strain_type": "Indica"
    },
    {
        "id": "a9a474ea-afa8-4ca3-ae11-d8e683053517",
        "initial_consumption_type": "Flower",
        "value": "Platinum OG",
        "strain_type": "Indica"
    },
    {
        "id": "e214d530-1b92-489c-b201-a0b0f20df228",
        "initial_consumption_type": "Flower",
        "value": "Platinum Purple Kush",
        "strain_type": "Indica"
    },
    {
        "id": "75bb4639-e45a-4699-b853-fc965681080e",
        "initial_consumption_type": "Flower",
        "value": "Platinum Purps",
        "strain_type": "Hybrid"
    },
    {
        "id": "ce11aea7-8b5e-4526-96a5-7b2e18236512",
        "initial_consumption_type": "Flower",
        "value": "Plum",
        "strain_type": "Indica"
    },
    {
        "id": "5bcc491d-36d1-4284-8f75-63dbf911b869",
        "initial_consumption_type": "Flower",
        "value": "Pluto Kush",
        "strain_type": "Indica"
    },
    {
        "id": "a04727b1-b308-4ce9-9577-0dc8a1e027bd",
        "initial_consumption_type": "Flower",
        "value": "Poison Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "642ac623-2367-4ba6-854d-c79d4a845127",
        "initial_consumption_type": "Flower",
        "value": "Popcorn Kush",
        "strain_type": "Indica"
    },
    {
        "id": "a4407165-dd0b-4ddb-a5d0-6d6bd1865d13",
        "initial_consumption_type": "Flower",
        "value": "Pot of Gold",
        "strain_type": "Indica"
    },
    {
        "id": "1cc4c931-addf-4300-a958-2407bb42cfc9",
        "initial_consumption_type": "Flower",
        "value": "Power Kush",
        "strain_type": "Indica"
    },
    {
        "id": "4952b6f4-c11a-4ddd-b8e2-105e017734ce",
        "initial_consumption_type": "Flower",
        "value": "Power Plant",
        "strain_type": "Hybrid"
    },
    {
        "id": "8bbd7b6a-2b10-4c25-84b2-38035f0e8e3a",
        "initial_consumption_type": "Flower",
        "value": "Pre-98 Bubba Kush",
        "strain_type": "Indica"
    },
    {
        "id": "a024d9b4-97dd-403f-812a-550338c9a0ef",
        "initial_consumption_type": "Flower",
        "value": "Premium KB Killer",
        "strain_type": "Hybrid"
    },
    {
        "id": "13b35336-221b-4d74-a253-de5437e3aed5",
        "initial_consumption_type": "Flower",
        "value": "Presidential OG",
        "strain_type": "Indica"
    },
    {
        "id": "a2236587-7a8e-4ff7-b37a-6e2339eb956d",
        "initial_consumption_type": "Flower",
        "value": "Pulp",
        "strain_type": "Indica"
    },
    {
        "id": "8b9e68c6-1507-413d-aeef-febc4e4a43ca",
        "initial_consumption_type": "Flower",
        "value": "Pure Afghan",
        "strain_type": "Indica"
    },
    {
        "id": "14edd2ef-d9fe-4aaf-9ef4-8ec9340eb781",
        "initial_consumption_type": "Flower",
        "value": "Pure Gold",
        "strain_type": "Hybrid"
    },
    {
        "id": "c6a8377a-19eb-4967-b6d5-00f6f0972242",
        "initial_consumption_type": "Flower",
        "value": "Pure Kush",
        "strain_type": "Indica"
    },
    {
        "id": "39c10db3-a4dc-492f-9256-a80d0852b352",
        "initial_consumption_type": "Flower",
        "value": "Pure OG",
        "strain_type": "Indica"
    },
    {
        "id": "d1189a1e-a8d7-42d2-8f00-1845f38dad20",
        "initial_consumption_type": "Flower",
        "value": "Pure OG Budder",
        "strain_type": "Hybrid"
    },
    {
        "id": "f54d4c59-dd3c-45e1-b3cc-59366cafeb36",
        "initial_consumption_type": "Flower",
        "value": "Pure Power Plant",
        "strain_type": "Sativa"
    },
    {
        "id": "54587e60-fd96-4144-aa91-120a7e2d562a",
        "initial_consumption_type": "Flower",
        "value": "Purple Afghani",
        "strain_type": "Indica"
    },
    {
        "id": "a1170517-a114-4155-852f-51af505c3fbc",
        "initial_consumption_type": "Flower",
        "value": "Purple AK-47",
        "strain_type": "Hybrid"
    },
    {
        "id": "945bfffa-4389-4640-b15c-62164f9c47c1",
        "initial_consumption_type": "Flower",
        "value": "Purple Arrow",
        "strain_type": "Hybrid"
    },
    {
        "id": "b5aa03d9-d0a7-4469-8b0e-2f6331e4fff2",
        "initial_consumption_type": "Flower",
        "value": "Purple Berry",
        "strain_type": "Indica"
    },
    {
        "id": "9aa42883-a3ef-464e-b39d-57f21ab97be7",
        "initial_consumption_type": "Flower",
        "value": "Purple Bubba Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "4221b57a-8c4b-4e65-9813-bd0a24817432",
        "initial_consumption_type": "Flower",
        "value": "Purple Buddha",
        "strain_type": "Indica"
    },
    {
        "id": "15911dfc-e910-49ab-a376-2f555511bf61",
        "initial_consumption_type": "Flower",
        "value": "Purple Butter",
        "strain_type": "Indica"
    },
    {
        "id": "03965a3f-839e-44b3-85bf-0256857f8393",
        "initial_consumption_type": "Flower",
        "value": "Purple Candy",
        "strain_type": "Indica"
    },
    {
        "id": "54e2f054-86e1-4250-8187-92542b1667dd",
        "initial_consumption_type": "Flower",
        "value": "Purple Cheese",
        "strain_type": "Sativa"
    },
    {
        "id": "c37590c7-cfd2-4561-8a09-e99f0ad085bd",
        "initial_consumption_type": "Flower",
        "value": "Purple Cream",
        "strain_type": "Indica"
    },
    {
        "id": "047950e2-7d4d-4c2d-b7fa-64c84e429eb5",
        "initial_consumption_type": "Flower",
        "value": "Purple Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "a3eecc1a-d6da-48e9-8740-d40873a60457",
        "initial_consumption_type": "Flower",
        "value": "Purple Dogg",
        "strain_type": "Hybrid"
    },
    {
        "id": "f7762653-b588-4072-8bd9-eac7b3cc6678",
        "initial_consumption_type": "Flower",
        "value": "Purple Dragon",
        "strain_type": "Indica"
    },
    {
        "id": "c6fe25ab-0a9a-4804-88be-cac0ff5779fc",
        "initial_consumption_type": "Flower",
        "value": "Purple Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "2875358d-96fe-4c8c-99c7-ca6a45762f0c",
        "initial_consumption_type": "Flower",
        "value": "Purple Erkle",
        "strain_type": "Hybrid"
    },
    {
        "id": "5e35b683-8420-43e5-a594-7499f9b11244",
        "initial_consumption_type": "Flower",
        "value": "Purple Goo",
        "strain_type": "Indica"
    },
    {
        "id": "b8b2eda1-275f-4908-9497-22773482a163",
        "initial_consumption_type": "Flower",
        "value": "Purple Hashplant",
        "strain_type": "Hybrid"
    },
    {
        "id": "ee06b8cb-a440-45f8-9c3e-0d221655c2ec",
        "initial_consumption_type": "Flower",
        "value": "Purple Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "88b288fc-4b77-48bc-a3e7-9899f0bb30a1",
        "initial_consumption_type": "Flower",
        "value": "Purple Ice",
        "strain_type": "Hybrid"
    },
    {
        "id": "3c3741ce-d231-4811-b70c-99295b52adcc",
        "initial_consumption_type": "Flower",
        "value": "Purple Kush",
        "strain_type": "Indica"
    },
    {
        "id": "1e15aebe-6905-4071-9dad-abad78a5e72c",
        "initial_consumption_type": "Flower",
        "value": "Purple Maroc",
        "strain_type": "Sativa"
    },
    {
        "id": "17f34d6f-b0f6-4cfc-b7ea-9c05127e9c56",
        "initial_consumption_type": "Flower",
        "value": "Purple Monkey Balls",
        "strain_type": "Hybrid"
    },
    {
        "id": "cd63805d-cca6-4f59-bec2-b875e827b689",
        "initial_consumption_type": "Flower",
        "value": "Purple Mr. Nice",
        "strain_type": "Indica"
    },
    {
        "id": "e1dc6bc8-c795-4172-a2f0-84d9f2f0c86c",
        "initial_consumption_type": "Flower",
        "value": "Purple Nepal",
        "strain_type": "Indica"
    },
    {
        "id": "41727a38-0772-4925-9a93-ffda0ee8be73",
        "initial_consumption_type": "Flower",
        "value": "Purple OG Kush",
        "strain_type": "Indica"
    },
    {
        "id": "0ba0a449-7d5f-49bc-915f-81485b1321cf",
        "initial_consumption_type": "Flower",
        "value": "Purple Passion",
        "strain_type": "Indica"
    },
    {
        "id": "03dbb189-875e-43c3-8c60-7a850195fd92",
        "initial_consumption_type": "Flower",
        "value": "Purple Pine",
        "strain_type": "Hybrid"
    },
    {
        "id": "eeea8ae0-86e6-4861-a2e7-b078d6a7448f",
        "initial_consumption_type": "Flower",
        "value": "Purple Pineberry",
        "strain_type": "Indica"
    },
    {
        "id": "7a681c28-dca0-4bd3-b0a6-c08cf01f65d0",
        "initial_consumption_type": "Flower",
        "value": "Purple Power",
        "strain_type": "Sativa"
    },
    {
        "id": "3b270b98-2a73-420f-a827-213407be4aea",
        "initial_consumption_type": "Flower",
        "value": "Purple Princess",
        "strain_type": "Hybrid"
    },
    {
        "id": "2848e822-f95a-4ab1-959f-5887798bb5b1",
        "initial_consumption_type": "Flower",
        "value": "Purple Pussy",
        "strain_type": "Hybrid"
    },
    {
        "id": "daf62b4b-f484-46ed-a7d1-1f7d18917363",
        "initial_consumption_type": "Flower",
        "value": "Purple Sage",
        "strain_type": "Hybrid"
    },
    {
        "id": "2e02ff3f-a2bd-463a-84b9-2331d20fb420",
        "initial_consumption_type": "Flower",
        "value": "Purple Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "5c3a3235-633a-44e6-b7cf-94aa070e4ebd",
        "initial_consumption_type": "Flower",
        "value": "Purple Snow",
        "strain_type": "Hybrid"
    },
    {
        "id": "1b26d469-e84a-436c-bd10-f329d24b6328",
        "initial_consumption_type": "Flower",
        "value": "Purple Sour Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "55b87e40-8c3b-433d-98d5-37bcf1ff4aeb",
        "initial_consumption_type": "Flower",
        "value": "Purple Tonic",
        "strain_type": "Indica"
    },
    {
        "id": "61c30adc-a043-436b-a842-f81d7e75b5da",
        "initial_consumption_type": "Flower",
        "value": "Purple Trainwreck",
        "strain_type": "Hybrid"
    },
    {
        "id": "a85f02f7-cecc-426b-a31e-1cc39ade55b5",
        "initial_consumption_type": "Flower",
        "value": "Purple Urkle",
        "strain_type": "Indica"
    },
    {
        "id": "0d5082d2-d1c9-4ae8-92ba-e93b7bf2a938",
        "initial_consumption_type": "Flower",
        "value": "Purple Urkle I.D.",
        "strain_type": "Indica"
    },
    {
        "id": "0878bc8e-e69d-46dd-bf0d-15c01c030eb2",
        "initial_consumption_type": "Flower",
        "value": "Purple Voodoo",
        "strain_type": "Hybrid"
    },
    {
        "id": "f0ce3e14-76c9-47a7-94cb-129a34069a9d",
        "initial_consumption_type": "Flower",
        "value": "Purple Wreck",
        "strain_type": "Indica"
    },
    {
        "id": "1b970d11-f2c1-4720-863a-c1612b0f4e05",
        "initial_consumption_type": "Flower",
        "value": "PVC OG",
        "strain_type": "Indica"
    },
    {
        "id": "1ce0294a-df0d-48fd-9708-782bef5b28d9",
        "initial_consumption_type": "Flower",
        "value": "Q3",
        "strain_type": "Sativa"
    },
    {
        "id": "226dd167-41a5-4b45-9ac1-82e841b45dc5",
        "initial_consumption_type": "Flower",
        "value": "Qleaner",
        "strain_type": "Sativa"
    },
    {
        "id": "1c5d96f1-4b47-44f0-b12e-6bad7a5cdceb",
        "initial_consumption_type": "Flower",
        "value": "Qrazy Train",
        "strain_type": "Hybrid"
    },
    {
        "id": "cea4c9b3-253d-4905-83f4-fa0b73c27e3a",
        "initial_consumption_type": "Flower",
        "value": "Quebec Gold",
        "strain_type": "Hybrid"
    },
    {
        "id": "184fd041-2354-4788-8073-a928891bb948",
        "initial_consumption_type": "Flower",
        "value": "Queen of Hearts",
        "strain_type": "Sativa"
    },
    {
        "id": "5ff00092-cf11-4a85-9e67-fa1133742cb0",
        "initial_consumption_type": "Flower",
        "value": "Querkle",
        "strain_type": "Hybrid"
    },
    {
        "id": "4ea35325-0ec8-41bc-be9d-5a3bbc0673e9",
        "initial_consumption_type": "Flower",
        "value": "Rafael",
        "strain_type": "Sativa"
    },
    {
        "id": "138057f2-0420-44aa-aeb7-f1a7e9b267e7",
        "initial_consumption_type": "Flower",
        "value": "Rainbow",
        "strain_type": "Hybrid"
    },
    {
        "id": "b91dd93b-2bf5-48e0-b14f-82c08fdd32d8",
        "initial_consumption_type": "Flower",
        "value": "Raskal OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "5b87e65b-2da0-4ae8-8c38-246164bb400b",
        "initial_consumption_type": "Flower",
        "value": "Raspberry Kush",
        "strain_type": "Indica"
    },
    {
        "id": "abe01ca0-5974-4d1f-9c9a-f203ed01d8b8",
        "initial_consumption_type": "Flower",
        "value": "Recon",
        "strain_type": "Hybrid"
    },
    {
        "id": "86e68a4c-3b86-4183-9100-d3c37b71a53a",
        "initial_consumption_type": "Flower",
        "value": "Red Beard",
        "strain_type": "Indica"
    },
    {
        "id": "27132f30-0b7d-4a7a-8fc4-60f43d0d3729",
        "initial_consumption_type": "Flower",
        "value": "Red Congolese",
        "strain_type": "Sativa"
    },
    {
        "id": "38bd2f53-3e2e-47ea-9469-5f93e0d6903e",
        "initial_consumption_type": "Flower",
        "value": "Red Dragon",
        "strain_type": "Hybrid"
    },
    {
        "id": "0877c622-f1a5-46d7-a73e-ff64362a8f52",
        "initial_consumption_type": "Flower",
        "value": "Red Dwarf",
        "strain_type": "Indica"
    },
    {
        "id": "0ae42e5b-7b41-4527-8a34-6dc4324e0164",
        "initial_consumption_type": "Flower",
        "value": "Red Eye OG",
        "strain_type": "Indica"
    },
    {
        "id": "dc7641e7-6d97-4cfc-a55c-f78e407c85b7",
        "initial_consumption_type": "Flower",
        "value": "Red Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "5b59467e-3377-4143-ace5-c2463cc16bff",
        "initial_consumption_type": "Flower",
        "value": "Redding OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "ef45c722-6855-46be-8618-76fcc175cd9c",
        "initial_consumption_type": "Flower",
        "value": "Redwood Kush",
        "strain_type": "Indica"
    },
    {
        "id": "d6d7c3d4-cfba-431a-962a-9b28141168e5",
        "initial_consumption_type": "Flower",
        "value": "Reggie",
        "strain_type": "Sativa"
    },
    {
        "id": "0ed9f083-26bb-4815-985f-a0a1478b1764",
        "initial_consumption_type": "Flower",
        "value": "Rhino Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "518bc022-084c-4310-89f8-6f6960c1196f",
        "initial_consumption_type": "Flower",
        "value": "Richie Rich",
        "strain_type": "Hybrid"
    },
    {
        "id": "717f4cde-8c54-45be-9783-99700470c417",
        "initial_consumption_type": "Flower",
        "value": "Rock Candy",
        "strain_type": "Hybrid"
    },
    {
        "id": "8745a359-4308-4f17-9713-f139eb80d0de",
        "initial_consumption_type": "Flower",
        "value": "Rocklock",
        "strain_type": "Hybrid"
    },
    {
        "id": "68ce51af-6c24-4476-8410-bfe0c09391e7",
        "initial_consumption_type": "Flower",
        "value": "Rockstar Master Kush",
        "strain_type": "Indica"
    },
    {
        "id": "efaaa744-7b2d-41ba-bbc0-05b343faf0e9",
        "initial_consumption_type": "Flower",
        "value": "Romping Goddess",
        "strain_type": "Hybrid"
    },
    {
        "id": "f3f2bf78-70f5-4f45-97ae-bf5097092cc5",
        "initial_consumption_type": "Flower",
        "value": "Romulan",
        "strain_type": "Indica"
    },
    {
        "id": "01c39f45-b2ff-4557-862d-3ee8359c58c6",
        "initial_consumption_type": "Flower",
        "value": "Romulan Cotton Candy",
        "strain_type": "Hybrid"
    },
    {
        "id": "9fb7ff12-1b6d-43ca-8d5e-48972a7e4254",
        "initial_consumption_type": "Flower",
        "value": "Romulan Grapefruit",
        "strain_type": "Hybrid"
    },
    {
        "id": "4b76e04f-b6c6-46de-bf62-d45d19947e3a",
        "initial_consumption_type": "Flower",
        "value": "Root Beer Kush",
        "strain_type": "Sativa"
    },
    {
        "id": "71683c4b-7689-4876-b25c-3b2dec69de9f",
        "initial_consumption_type": "Flower",
        "value": "Route 66",
        "strain_type": "Hybrid"
    },
    {
        "id": "3be9e541-2641-4d00-8697-3c15d8f75eb6",
        "initial_consumption_type": "Flower",
        "value": "RSZ Blueberry Garlic",
        "strain_type": "Hybrid"
    },
    {
        "id": "d0cd2d71-a997-4338-b2d8-475dff4f026f",
        "initial_consumption_type": "Flower",
        "value": "Runuponyah",
        "strain_type": "Indica"
    },
    {
        "id": "f214ac2f-7e9b-4e97-a246-31dee7729b4d",
        "initial_consumption_type": "Flower",
        "value": "Russian Rocket Fuel",
        "strain_type": "Hybrid"
    },
    {
        "id": "05d9e859-68c9-443c-bc3e-484c9336e995",
        "initial_consumption_type": "Flower",
        "value": "Sage",
        "strain_type": "Hybrid"
    },
    {
        "id": "6a0cad2d-a7c2-4e1e-8f95-19ecde859831",
        "initial_consumption_type": "Flower",
        "value": "Sage N Sour",
        "strain_type": "Sativa"
    },
    {
        "id": "e3028987-3d1e-467b-9348-2480536c0054",
        "initial_consumption_type": "Flower",
        "value": "Sandman",
        "strain_type": "Hybrid"
    },
    {
        "id": "12b9f200-775b-403e-953a-b0af0f58f1e8",
        "initial_consumption_type": "Flower",
        "value": "Sandstorm",
        "strain_type": "Indica"
    },
    {
        "id": "ceb8e4d8-01c2-4dc2-994f-88e77841c2ff",
        "initial_consumption_type": "Flower",
        "value": "Sapphire Star",
        "strain_type": "Hybrid"
    },
    {
        "id": "33e7743f-6049-4d4f-9d23-ab02c07689c0",
        "initial_consumption_type": "Flower",
        "value": "Satori",
        "strain_type": "Hybrid"
    },
    {
        "id": "ab674107-e6f7-4c07-9a17-0454382b6eb1",
        "initial_consumption_type": "Flower",
        "value": "Seattle Blue",
        "strain_type": "Indica"
    },
    {
        "id": "d6c0ff17-9c9e-49bb-be7b-410e95a3bb5b",
        "initial_consumption_type": "Flower",
        "value": "Sensativa",
        "strain_type": "Sativa"
    },
    {
        "id": "27d3ecfc-859e-4ad4-8fab-367918d9cd3f",
        "initial_consumption_type": "Flower",
        "value": "Sensi Star",
        "strain_type": "Indica"
    },
    {
        "id": "bd04c044-53ca-4ed5-9c51-60331a4b7875",
        "initial_consumption_type": "Flower",
        "value": "Sensi Star x AK47",
        "strain_type": "Hybrid"
    },
    {
        "id": "922855f4-dd95-435a-b6b3-877ae6ec3043",
        "initial_consumption_type": "Flower",
        "value": "SFV OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "5b46735c-8063-46d9-a57d-a47a07d790c4",
        "initial_consumption_type": "Flower",
        "value": "Shaman",
        "strain_type": "Sativa"
    },
    {
        "id": "14c1c8cb-33c1-4092-9d31-9afb91fbe280",
        "initial_consumption_type": "Flower",
        "value": "Shark Shock",
        "strain_type": "Indica"
    },
    {
        "id": "a23a3fde-d3ea-4373-8904-43c84cc2bfc2",
        "initial_consumption_type": "Flower",
        "value": "Sharksbreath",
        "strain_type": "Hybrid"
    },
    {
        "id": "e3c57b6f-049e-4bbc-8fc2-fcdce01e8fd4",
        "initial_consumption_type": "Flower",
        "value": "Shipwreck",
        "strain_type": "Sativa"
    },
    {
        "id": "bd95de75-5e15-4a5c-988e-814172176f64",
        "initial_consumption_type": "Flower",
        "value": "Shishkaberry",
        "strain_type": "Hybrid"
    },
    {
        "id": "9fe7a004-50b9-4023-aaca-001b56671f12",
        "initial_consumption_type": "Flower",
        "value": "Shiva Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "3ec09c15-f2ca-4e73-afa9-1dd39874a2b0",
        "initial_consumption_type": "Flower",
        "value": "Shiva X",
        "strain_type": "Hybrid"
    },
    {
        "id": "eaea15a6-7862-4fb6-b14a-fc7e0769f903",
        "initial_consumption_type": "Flower",
        "value": "Shoreline",
        "strain_type": "Hybrid"
    },
    {
        "id": "1dd2021c-3f05-4cb8-bd36-11f0dfb6d730",
        "initial_consumption_type": "Flower",
        "value": "Sierra Mist",
        "strain_type": "Hybrid"
    },
    {
        "id": "8f88dd7a-5e04-45e7-8499-df6f30443c76",
        "initial_consumption_type": "Flower",
        "value": "Silver Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "4595a80d-2770-4c6b-a7d6-606a2fc6b451",
        "initial_consumption_type": "Flower",
        "value": "Silver Pearl",
        "strain_type": "Hybrid"
    },
    {
        "id": "a9bddfa0-ce92-424f-82b3-cd6a592facc5",
        "initial_consumption_type": "Flower",
        "value": "Silver Surfer",
        "strain_type": "Hybrid"
    },
    {
        "id": "5c9723f6-46b8-4745-bcb6-05d741a36e50",
        "initial_consumption_type": "Flower",
        "value": "Silver Tip",
        "strain_type": "Hybrid"
    },
    {
        "id": "6ce56d6f-b18f-4751-a965-ec4a671100fe",
        "initial_consumption_type": "Flower",
        "value": "Silverback Gorilla",
        "strain_type": "Indica"
    },
    {
        "id": "68c9ddfe-c5ba-4604-bb0e-61c35e798121",
        "initial_consumption_type": "Flower",
        "value": "Silverfuck",
        "strain_type": "Indica"
    },
    {
        "id": "3af55ec5-e71a-402f-bcb3-383e3efa0eea",
        "initial_consumption_type": "Flower",
        "value": "Skittlz",
        "strain_type": "Hybrid"
    },
    {
        "id": "2dad3183-fdd8-4260-aad5-9913cded800b",
        "initial_consumption_type": "Flower",
        "value": "Skunk #1",
        "strain_type": "Sativa"
    },
    {
        "id": "e1d2330a-7373-4720-b0f2-9e85f8c8f8e8",
        "initial_consumption_type": "Flower",
        "value": "Skunk #9",
        "strain_type": "Indica"
    },
    {
        "id": "f3f7e60a-2e99-488f-ba68-b2bfb637f522",
        "initial_consumption_type": "Flower",
        "value": "Skunk 11",
        "strain_type": "Hybrid"
    },
    {
        "id": "d91c171a-0cf6-4238-a3fb-b1b0bf9df2a0",
        "initial_consumption_type": "Flower",
        "value": "Skunky Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "4d248972-e87d-4820-8f52-451fc0d67659",
        "initial_consumption_type": "Flower",
        "value": "Skydog",
        "strain_type": "Hybrid"
    },
    {
        "id": "e3235140-a891-4eb8-9370-fff36fc5893a",
        "initial_consumption_type": "Flower",
        "value": "Skywalker",
        "strain_type": "Indica"
    },
    {
        "id": "10f47272-4e8c-4e3c-8ed3-a8669e811709",
        "initial_consumption_type": "Flower",
        "value": "Skywalker OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "e515b428-bbeb-4c17-a12e-d1110c586dca",
        "initial_consumption_type": "Flower",
        "value": "Sleestack X Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "7a14cbaf-f837-4a8d-b6c5-67aaf48469f8",
        "initial_consumption_type": "Flower",
        "value": "Sloppy Bowl",
        "strain_type": "Indica"
    },
    {
        "id": "729a0f61-2157-414d-ab34-868963b84beb",
        "initial_consumption_type": "Flower",
        "value": "Smelly Guy",
        "strain_type": "Indica"
    },
    {
        "id": "5566975e-9e1b-4f36-b18c-8f4ca43c4f2e",
        "initial_consumption_type": "Flower",
        "value": "Snoop’s Dream",
        "strain_type": "Indica"
    },
    {
        "id": "6c9921f0-d222-4ffb-a1c9-bf2bb7f73aa9",
        "initial_consumption_type": "Flower",
        "value": "Snoop’s Master Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "157f2b93-d68c-4226-b09a-e4b663e85797",
        "initial_consumption_type": "Flower",
        "value": "Snow Monster",
        "strain_type": "Indica"
    },
    {
        "id": "b4f68634-37cd-41f5-a93a-fc540f3407d6",
        "initial_consumption_type": "Flower",
        "value": "Snow White",
        "strain_type": "Hybrid"
    },
    {
        "id": "f89803de-e56b-4c92-a430-e79581aff473",
        "initial_consumption_type": "Flower",
        "value": "Snow Wreck",
        "strain_type": "Hybrid"
    },
    {
        "id": "d2718324-c235-4144-8692-a55f7d3d7e97",
        "initial_consumption_type": "Flower",
        "value": "Snowcap",
        "strain_type": "Sativa"
    },
    {
        "id": "915dbcdb-0238-457b-95f0-32a042a5b181",
        "initial_consumption_type": "Flower",
        "value": "So Gouda",
        "strain_type": "Hybrid"
    },
    {
        "id": "822a7668-62e5-4e4a-994b-20684677adb6",
        "initial_consumption_type": "Flower",
        "value": "Sorry Sucker",
        "strain_type": "Hybrid"
    },
    {
        "id": "239339ce-1e0d-4e45-bbd2-5ccd4130e1a0",
        "initial_consumption_type": "Flower",
        "value": "Soul Assassin OG",
        "strain_type": "Indica"
    },
    {
        "id": "8568e423-bb63-4628-8566-6f557e319e78",
        "initial_consumption_type": "Flower",
        "value": "Soul Shine",
        "strain_type": "Hybrid"
    },
    {
        "id": "15efeb84-9c14-49ff-94ec-cf37fd417890",
        "initial_consumption_type": "Flower",
        "value": "Sour Apple",
        "strain_type": "Hybrid"
    },
    {
        "id": "bf29594d-5bc0-4dc4-883e-80f272814df3",
        "initial_consumption_type": "Flower",
        "value": "Sour Bubble",
        "strain_type": "Hybrid"
    },
    {
        "id": "f43e4940-faa1-41b3-a9de-e8feeac2ee48",
        "initial_consumption_type": "Flower",
        "value": "Sour Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "594d4e0a-c4f6-4bc0-89e7-3d9ceab174e7",
        "initial_consumption_type": "Flower",
        "value": "Sour Chocolate",
        "strain_type": "Sativa"
    },
    {
        "id": "ee699a3a-8ce3-43db-b6c7-b2ef9e2796f5",
        "initial_consumption_type": "Flower",
        "value": "Sour Cream",
        "strain_type": "Hybrid"
    },
    {
        "id": "49db3758-b9ba-4376-8ed7-43537ec19a01",
        "initial_consumption_type": "Flower",
        "value": "Sour Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "b3c9ff15-077d-42d5-86cb-a56179993f18",
        "initial_consumption_type": "Flower",
        "value": "Sour Diesel #2",
        "strain_type": "Hybrid"
    },
    {
        "id": "2da97657-de66-4bc5-b494-7291a1f645ae",
        "initial_consumption_type": "Flower",
        "value": "Sour Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "289e7419-69b6-4d17-986a-b0bc8d29a83e",
        "initial_consumption_type": "Flower",
        "value": "Sour Flower",
        "strain_type": "Sativa"
    },
    {
        "id": "69e49de0-3372-44ca-8956-e2a95599a8f2",
        "initial_consumption_type": "Flower",
        "value": "Sour Grape",
        "strain_type": "Hybrid"
    },
    {
        "id": "61af0e26-ea79-4690-86f5-1a7bbb18ba56",
        "initial_consumption_type": "Flower",
        "value": "Sour Grapes",
        "strain_type": "Hybrid"
    },
    {
        "id": "5d6e3cae-47ba-4c92-a4eb-1b2982df19a2",
        "initial_consumption_type": "Flower",
        "value": "Sour Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "9d963d8f-1430-46a8-ad48-d2c11cc16689",
        "initial_consumption_type": "Flower",
        "value": "Sour Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "09194a4e-efc3-4356-bb7b-ad74b5cf6cd4",
        "initial_consumption_type": "Flower",
        "value": "Sour OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "9dccb68b-94d2-4ce8-90a4-c4bb9622a38e",
        "initial_consumption_type": "Flower",
        "value": "Sour OG Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "ce47da7f-85fd-447a-b4c3-dcb4160c15fb",
        "initial_consumption_type": "Flower",
        "value": "Sour Power",
        "strain_type": "Hybrid"
    },
    {
        "id": "d72f1262-dcf1-41b6-bb59-7dace687435d",
        "initial_consumption_type": "Flower",
        "value": "Sour Russian",
        "strain_type": "Hybrid"
    },
    {
        "id": "29658d74-061a-4d72-8f59-64e655763f3a",
        "initial_consumption_type": "Flower",
        "value": "Sour Skywalker OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "78fbb325-107e-4354-a7a0-2755df160fc2",
        "initial_consumption_type": "Flower",
        "value": "Sour Tsunami",
        "strain_type": "Hybrid"
    },
    {
        "id": "9b20e7cc-c38b-4830-b38b-10643045a785",
        "initial_consumption_type": "Flower",
        "value": "Space Bomb",
        "strain_type": "Hybrid"
    },
    {
        "id": "661bd09c-fb56-4b4f-916c-45be6dd64cec",
        "initial_consumption_type": "Flower",
        "value": "Space Dawg",
        "strain_type": "Indica"
    },
    {
        "id": "f292a578-d1d8-46a1-b3a8-a263b47a4524",
        "initial_consumption_type": "Flower",
        "value": "Space Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "412b1516-b7e8-46e1-8b8b-1501f617c890",
        "initial_consumption_type": "Flower",
        "value": "Space Queen",
        "strain_type": "Hybrid"
    },
    {
        "id": "451a4e99-b51d-4021-bda9-93b48eb86522",
        "initial_consumption_type": "Flower",
        "value": "Spawntanica",
        "strain_type": "Indica"
    },
    {
        "id": "d264d1ab-2819-4e05-93eb-bde479073066",
        "initial_consumption_type": "Flower",
        "value": "Special K",
        "strain_type": "Hybrid"
    },
    {
        "id": "e069b021-2365-4721-996e-abf825aeb23a",
        "initial_consumption_type": "Flower",
        "value": "Special Queen",
        "strain_type": "Hybrid"
    },
    {
        "id": "010e1774-a2ae-4667-9985-36eb1092d489",
        "initial_consumption_type": "Flower",
        "value": "Spurkle",
        "strain_type": "Indica"
    },
    {
        "id": "3b584833-2c3a-4199-ba4d-b311e7c7c72f",
        "initial_consumption_type": "Flower",
        "value": "Sputnik",
        "strain_type": "Hybrid"
    },
    {
        "id": "26c0a0be-b121-47cc-93a2-41cc9c2e75c5",
        "initial_consumption_type": "Flower",
        "value": "Star Nebula",
        "strain_type": "Indica"
    },
    {
        "id": "19dbdd4b-95b6-4d97-95b4-19bc8ac8de0c",
        "initial_consumption_type": "Flower",
        "value": "Starry Night",
        "strain_type": "Hybrid"
    },
    {
        "id": "271701c2-22d0-4bc2-a743-a991a9f01288",
        "initial_consumption_type": "Flower",
        "value": "Stevie Wonder",
        "strain_type": "Hybrid"
    },
    {
        "id": "d867c447-c688-46c5-86cd-288b8edcb9de",
        "initial_consumption_type": "Flower",
        "value": "Sticky Icky OG Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "61ebd8a9-8e83-4f4d-9002-b425ac83df7e",
        "initial_consumption_type": "Flower",
        "value": "Stinky Pete",
        "strain_type": "Sativa"
    },
    {
        "id": "a118517c-74c9-47fd-b21b-96683e7b1312",
        "initial_consumption_type": "Flower",
        "value": "Strawberry",
        "strain_type": "Sativa"
    },
    {
        "id": "d24cd6c0-0eb4-4fa6-a999-139544661a28",
        "initial_consumption_type": "Flower",
        "value": "Strawberry Banana",
        "strain_type": "Hybrid"
    },
    {
        "id": "a20bb1a8-d105-447a-ac20-ce1c91f64bf2",
        "initial_consumption_type": "Flower",
        "value": "Strawberry Cough",
        "strain_type": "Hybrid"
    },
    {
        "id": "557d9e0f-7aea-45a6-a865-2705ae8d8fd1",
        "initial_consumption_type": "Flower",
        "value": "Strawberry Diesel",
        "strain_type": "Hybrid"
    },
    {
        "id": "ce43b692-81f0-4642-9640-b26005fccd59",
        "initial_consumption_type": "Flower",
        "value": "Strawberry Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "39e58435-991d-4239-8aaa-f75f02a1f1d2",
        "initial_consumption_type": "Flower",
        "value": "Strawberry Kush",
        "strain_type": "Indica"
    },
    {
        "id": "a3889b85-f620-4193-9961-67ba57973bbc",
        "initial_consumption_type": "Flower",
        "value": "Stutterlicious OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "7055b9d8-adb3-4871-88d2-72a737faa0b8",
        "initial_consumption_type": "Flower",
        "value": "Sublime",
        "strain_type": "Indica"
    },
    {
        "id": "c5557280-d7e1-4e3e-997d-0674b1dd3c12",
        "initial_consumption_type": "Flower",
        "value": "Sugar Green Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "a19e7bff-9189-4d27-8b45-b59d8b96dd7c",
        "initial_consumption_type": "Flower",
        "value": "Sugar Shack",
        "strain_type": "Hybrid"
    },
    {
        "id": "54134cef-cb38-444a-b027-0417d840205b",
        "initial_consumption_type": "Flower",
        "value": "Sugar Skunk",
        "strain_type": "Indica"
    },
    {
        "id": "8b03c2a0-d829-4339-af51-d7f1a209bb01",
        "initial_consumption_type": "Flower",
        "value": "Super Blue Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "43087e1b-6571-4715-ae7b-e037d185f21b",
        "initial_consumption_type": "Flower",
        "value": "Super Cat Piss",
        "strain_type": "Sativa"
    },
    {
        "id": "b556b7ac-f068-46c7-a11c-9a4e410c7fde",
        "initial_consumption_type": "Flower",
        "value": "Super Goo",
        "strain_type": "Hybrid"
    },
    {
        "id": "c0540f5f-13b0-4e0b-8a30-bb8042865bf3",
        "initial_consumption_type": "Flower",
        "value": "Super Green Crack",
        "strain_type": "Sativa"
    },
    {
        "id": "b2c0b6eb-5242-4e2a-90a9-d60d05b04ad7",
        "initial_consumption_type": "Flower",
        "value": "Super Kush",
        "strain_type": "Indica"
    },
    {
        "id": "df895170-c32f-48ad-a2d4-3811b50e2208",
        "initial_consumption_type": "Flower",
        "value": "Super Lemon Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "bfe274a5-dabe-49ea-b185-1924a8b64377",
        "initial_consumption_type": "Flower",
        "value": "Super Lemon Skunk",
        "strain_type": "Indica"
    },
    {
        "id": "0b4d370e-de5e-4d8a-9d42-9f87a8bb30dc",
        "initial_consumption_type": "Flower",
        "value": "Super MelonHead Kush",
        "strain_type": "Indica"
    },
    {
        "id": "f56d9b29-84fa-43ff-befb-fa022dc2d41d",
        "initial_consumption_type": "Flower",
        "value": "Super OG Master Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "f61312fa-9daa-4c3e-98c6-44104de8b2fa",
        "initial_consumption_type": "Flower",
        "value": "Super Silver Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "0b4d02e2-2007-45ef-ad14-983b2a561635",
        "initial_consumption_type": "Flower",
        "value": "Super Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "a5b93313-e175-4b1c-a6af-4aa9220a46cb",
        "initial_consumption_type": "Flower",
        "value": "Super Sour Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "2930386b-7cd4-4f76-86df-917824d3d0f6",
        "initial_consumption_type": "Flower",
        "value": "Super Sour Widow",
        "strain_type": "Hybrid"
    },
    {
        "id": "72072e9f-3ab0-4428-a7b2-36e493af452b",
        "initial_consumption_type": "Flower",
        "value": "Superman OG",
        "strain_type": "Indica"
    },
    {
        "id": "8d293087-e5f5-47b0-af4f-33c86294574e",
        "initial_consumption_type": "Flower",
        "value": "Supernova",
        "strain_type": "Hybrid"
    },
    {
        "id": "0ee820cf-5fed-4879-af60-a7988b5631a4",
        "initial_consumption_type": "Flower",
        "value": "Superstar",
        "strain_type": "Hybrid"
    },
    {
        "id": "3f7e46fc-0792-4a09-84f8-96e056ff6136",
        "initial_consumption_type": "Flower",
        "value": "Sweet Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "6fbb9188-6300-44b7-8b56-eab4dd44f9cf",
        "initial_consumption_type": "Flower",
        "value": "Sweet Deep Grapefruit",
        "strain_type": "Indica"
    },
    {
        "id": "3a73eb3a-39c7-40ec-b45c-c15b2271880e",
        "initial_consumption_type": "Flower",
        "value": "Sweet Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "b12cae1d-6358-4847-b071-6c143a77c4a9",
        "initial_consumption_type": "Flower",
        "value": "Sweet Dreams",
        "strain_type": "Indica"
    },
    {
        "id": "b18ae605-ae84-40e4-adcf-e319ff1bcaf6",
        "initial_consumption_type": "Flower",
        "value": "Sweet Dutch",
        "strain_type": "Sativa"
    },
    {
        "id": "ac52ae6c-8c3e-42c3-9f17-57bfc4b1df9c",
        "initial_consumption_type": "Flower",
        "value": "Sweet Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "410ce606-7f9d-41b6-9b54-298dc5d419bb",
        "initial_consumption_type": "Flower",
        "value": "Sweet Island Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "f2c73066-18ea-4331-a86b-f7b55d2014bf",
        "initial_consumption_type": "Flower",
        "value": "Sweet Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "9d62a385-eb1e-480b-a98c-0d8ba7954312",
        "initial_consumption_type": "Flower",
        "value": "Sweet Tooth",
        "strain_type": "Hybrid"
    },
    {
        "id": "4da5aa96-330b-4006-920e-0d102039ce42",
        "initial_consumption_type": "Flower",
        "value": "Swiss Bliss",
        "strain_type": "Hybrid"
    },
    {
        "id": "ec3af024-1e60-4bb7-a09b-48649e4d15da",
        "initial_consumption_type": "Flower",
        "value": "Tahoe OG",
        "strain_type": "Indica"
    },
    {
        "id": "b1cd7ddf-8c45-46c3-9a30-ca8276b18cfb",
        "initial_consumption_type": "Flower",
        "value": "Taliban Poison",
        "strain_type": "Indica"
    },
    {
        "id": "ac8a17d1-dceb-47b4-bf84-685875edb43c",
        "initial_consumption_type": "Flower",
        "value": "Tangerine",
        "strain_type": "Hybrid"
    },
    {
        "id": "b833c0d9-61f6-4a7b-b982-ebf55046465d",
        "initial_consumption_type": "Flower",
        "value": "Tangerine Dream",
        "strain_type": "Hybrid"
    },
    {
        "id": "159e9f08-9bd6-47b8-a71e-446ad2f607cd",
        "initial_consumption_type": "Flower",
        "value": "Tangerine Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "a0fa6536-0903-4f4b-a943-68a5c0c409ef",
        "initial_consumption_type": "Flower",
        "value": "Tangerine Kush",
        "strain_type": "Indica"
    },
    {
        "id": "2d0f6a8b-31c5-47d9-b3e2-52942bd3c621",
        "initial_consumption_type": "Flower",
        "value": "Tangie",
        "strain_type": "Hybrid"
    },
    {
        "id": "8684fccc-7268-46ec-8b52-10f5c9073461",
        "initial_consumption_type": "Flower",
        "value": "Tessa",
        "strain_type": "Indica"
    },
    {
        "id": "4f38d153-5683-4897-be1e-8bdc6ee11d31",
        "initial_consumption_type": "Flower",
        "value": "Thai",
        "strain_type": "Sativa"
    },
    {
        "id": "6748da48-2bd4-4f62-aad1-bc614f15ec84",
        "initial_consumption_type": "Flower",
        "value": "Thai Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "2da2aa37-8841-41ee-9e5d-72b53b7df7db",
        "initial_consumption_type": "Flower",
        "value": "Thai-Tanic",
        "strain_type": "Hybrid"
    },
    {
        "id": "f691661b-8d60-480e-bd1b-80fc407101d9",
        "initial_consumption_type": "Flower",
        "value": "Thaidal Wave",
        "strain_type": "Hybrid"
    },
    {
        "id": "2466c8f7-0655-4c79-9793-d648b845d4c1",
        "initial_consumption_type": "Flower",
        "value": "THC Bomb",
        "strain_type": "Hybrid"
    },
    {
        "id": "8a9f8d70-3b3d-46dc-96f3-3dff59d0473c",
        "initial_consumption_type": "Flower",
        "value": "The Church",
        "strain_type": "Hybrid"
    },
    {
        "id": "3d9c3271-fbd2-4fce-b429-fb8aae9a6b1d",
        "initial_consumption_type": "Flower",
        "value": "The Flav",
        "strain_type": "Hybrid"
    },
    {
        "id": "4a731d05-1171-49d3-9db4-90a23d04a68a",
        "initial_consumption_type": "Flower",
        "value": "The Magic",
        "strain_type": "Hybrid"
    },
    {
        "id": "74bbce0d-3c86-43aa-9a1a-0d2e4e4d048a",
        "initial_consumption_type": "Flower",
        "value": "The OG Skunk",
        "strain_type": "Indica"
    },
    {
        "id": "964cc9db-2078-4efd-b5cb-111662a41675",
        "initial_consumption_type": "Flower",
        "value": "The Palin",
        "strain_type": "Hybrid"
    },
    {
        "id": "13fea0a3-341c-4f8a-ab80-25426e792491",
        "initial_consumption_type": "Flower",
        "value": "The Purp",
        "strain_type": "Indica"
    },
    {
        "id": "79fb42f3-3815-4987-baa8-d6751a3a07d7",
        "initial_consumption_type": "Flower",
        "value": "The Purps",
        "strain_type": "Hybrid"
    },
    {
        "id": "89f083b2-d816-4010-b53f-92851e9db224",
        "initial_consumption_type": "Flower",
        "value": "The Teenone",
        "strain_type": "Hybrid"
    },
    {
        "id": "dfbc28f9-5ca0-4c8c-989b-4513eaa8ea55",
        "initial_consumption_type": "Flower",
        "value": "The Void",
        "strain_type": "Hybrid"
    },
    {
        "id": "aa99ac6a-45e0-4ef8-bece-1f8859814d18",
        "initial_consumption_type": "Flower",
        "value": "The White",
        "strain_type": "Hybrid"
    },
    {
        "id": "02e954ca-9f2a-4eaa-afdd-2da295becbc5",
        "initial_consumption_type": "Flower",
        "value": "The Wiz",
        "strain_type": "Hybrid"
    },
    {
        "id": "2cbf12f6-5b84-4b6a-b833-8a87441a51f8",
        "initial_consumption_type": "Flower",
        "value": "Thin Mint",
        "strain_type": "Hybrid"
    },
    {
        "id": "acc73221-3b43-4c7d-b272-5f4a9c0030f5",
        "initial_consumption_type": "Flower",
        "value": "Tiger Woods",
        "strain_type": "Hybrid"
    },
    {
        "id": "1391e9ab-a78e-49fa-8ba4-dbf5cc060a19",
        "initial_consumption_type": "Flower",
        "value": "Top 44",
        "strain_type": "Indica"
    },
    {
        "id": "f5427798-17a3-47c4-a200-7e3dbac174e1",
        "initial_consumption_type": "Flower",
        "value": "Tora Bora",
        "strain_type": "Indica"
    },
    {
        "id": "4122f22d-1300-4c58-b440-1ecd7ed2b7d6",
        "initial_consumption_type": "Flower",
        "value": "Trainwreck",
        "strain_type": "Hybrid"
    },
    {
        "id": "3b698982-f362-4669-825b-652e96d18c0c",
        "initial_consumption_type": "Flower",
        "value": "Trainwreck #2",
        "strain_type": "Hybrid"
    },
    {
        "id": "c824ac4f-5953-4c20-a5f9-52375a9306fa",
        "initial_consumption_type": "Flower",
        "value": "Trident",
        "strain_type": "Hybrid"
    },
    {
        "id": "4fc8bab1-51bd-4f4a-9c0b-b078610debca",
        "initial_consumption_type": "Flower",
        "value": "Trifecta",
        "strain_type": "Hybrid"
    },
    {
        "id": "5b047be1-0910-46a2-88c5-8566b16e6d00",
        "initial_consumption_type": "Flower",
        "value": "Trinity",
        "strain_type": "Hybrid"
    },
    {
        "id": "b7b08ccf-46f8-49e6-b7f3-cd11f5fb1c9a",
        "initial_consumption_type": "Flower",
        "value": "Triple Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "52cbdadb-2ac0-480f-be76-1a3b209555eb",
        "initial_consumption_type": "Flower",
        "value": "Tropical Tang",
        "strain_type": "Hybrid"
    },
    {
        "id": "5ea1d46f-bf0b-4484-9080-fc581db703c7",
        "initial_consumption_type": "Flower",
        "value": "Tropicali",
        "strain_type": "Hybrid"
    },
    {
        "id": "fe60acef-0742-4346-bdb0-884a46684c65",
        "initial_consumption_type": "Flower",
        "value": "True OG",
        "strain_type": "Indica"
    },
    {
        "id": "6bc8ec25-9d4b-420d-a035-feb2f1e8312e",
        "initial_consumption_type": "Flower",
        "value": "Tsunami Crush",
        "strain_type": "Sativa"
    },
    {
        "id": "fb773ade-2ebe-4d4b-b6ee-63699a31536d",
        "initial_consumption_type": "Flower",
        "value": "Twilight Indica",
        "strain_type": "Indica"
    },
    {
        "id": "5bf4e708-f06f-4fb7-9ae0-59122acfd214",
        "initial_consumption_type": "Flower",
        "value": "UBC Chemo",
        "strain_type": "Hybrid"
    },
    {
        "id": "62d6d374-3696-41a1-9964-8604239b58a4",
        "initial_consumption_type": "Flower",
        "value": "UK Cheese",
        "strain_type": "Hybrid"
    },
    {
        "id": "a62fdb91-b926-4a37-8130-0c50962262fb",
        "initial_consumption_type": "Flower",
        "value": "Ultimate Indica",
        "strain_type": "Indica"
    },
    {
        "id": "86a2f2cd-945a-49d1-8fe8-ae3fb1bf7f7b",
        "initial_consumption_type": "Flower",
        "value": "Ultimate Trainwreck",
        "strain_type": "Sativa"
    },
    {
        "id": "32a1cec4-4c78-4ec8-9c05-b109363a3a22",
        "initial_consumption_type": "Flower",
        "value": "UW",
        "strain_type": "Indica"
    },
    {
        "id": "b9e5213d-8193-44d9-bc34-27509336cea1",
        "initial_consumption_type": "Flower",
        "value": "Vancity Kush",
        "strain_type": "Indica"
    },
    {
        "id": "4c7a090f-4bd1-4f2b-afe9-938d83171860",
        "initial_consumption_type": "Flower",
        "value": "Vanilla Kush",
        "strain_type": "Indica"
    },
    {
        "id": "06218697-31dc-4cb1-bca0-68a5faa0aad1",
        "initial_consumption_type": "Flower",
        "value": "Venice OG",
        "strain_type": "Sativa"
    },
    {
        "id": "7b00abbe-50f0-405e-85eb-f90fd5f11a5d",
        "initial_consumption_type": "Flower",
        "value": "Venom OG Kush",
        "strain_type": "Indica"
    },
    {
        "id": "d1b92591-56c2-4cc5-8644-56f412d9d001",
        "initial_consumption_type": "Flower",
        "value": "Verde Electric",
        "strain_type": "Hybrid"
    },
    {
        "id": "8f2eea1e-7e96-498a-b593-9f7dedaf0ab2",
        "initial_consumption_type": "Flower",
        "value": "Very Berry Haze",
        "strain_type": "Sativa"
    },
    {
        "id": "8a77b58b-be18-4097-8899-a8bdfcc5190a",
        "initial_consumption_type": "Flower",
        "value": "Violator Kush",
        "strain_type": "Indica"
    },
    {
        "id": "317be27d-c5a4-4266-8e33-84cee5f0bb90",
        "initial_consumption_type": "Flower",
        "value": "Voodoo",
        "strain_type": "Sativa"
    },
    {
        "id": "202da922-4fbb-4605-b3ed-4ce3b4eadaf5",
        "initial_consumption_type": "Flower",
        "value": "Vortex",
        "strain_type": "Hybrid"
    },
    {
        "id": "ffabf137-f2c2-43e3-bc7c-445ae717d0fe",
        "initial_consumption_type": "Flower",
        "value": "Waipi’o Hapa",
        "strain_type": "Sativa"
    },
    {
        "id": "48879713-7b90-4242-81f8-3148cbfb0ec8",
        "initial_consumption_type": "Flower",
        "value": "Waldo",
        "strain_type": "Hybrid"
    },
    {
        "id": "eb948f0e-f427-4497-9fa1-2f74163cf6db",
        "initial_consumption_type": "Flower",
        "value": "Walrus Kush",
        "strain_type": "Hybrid"
    },
    {
        "id": "b2994145-0074-4872-8058-3de589d09d3f",
        "initial_consumption_type": "Flower",
        "value": "Wappa",
        "strain_type": "Indica"
    },
    {
        "id": "f5cb5a88-1fee-47c8-b870-a44ac5f45b42",
        "initial_consumption_type": "Flower",
        "value": "Warlock",
        "strain_type": "Hybrid"
    },
    {
        "id": "21200cc4-ff9d-4759-9193-b2cad6558598",
        "initial_consumption_type": "Flower",
        "value": "Whitaker Blues",
        "strain_type": "Hybrid"
    },
    {
        "id": "50064721-c511-4eb4-90c9-c6026e6d4a31",
        "initial_consumption_type": "Flower",
        "value": "White Berry",
        "strain_type": "Hybrid"
    },
    {
        "id": "97afc37a-e31d-4b44-973f-7324e4544f8a",
        "initial_consumption_type": "Flower",
        "value": "White Dawg",
        "strain_type": "Hybrid"
    },
    {
        "id": "48aab246-c602-4956-bb59-8e55d474290b",
        "initial_consumption_type": "Flower",
        "value": "White Diesel",
        "strain_type": "Sativa"
    },
    {
        "id": "b0b3d1ea-7901-4c64-b588-2901045a0390",
        "initial_consumption_type": "Flower",
        "value": "White Fire",
        "strain_type": "Sativa"
    },
    {
        "id": "6a72fe6d-17d1-4058-b94d-83f7a525a33e",
        "initial_consumption_type": "Flower",
        "value": "White Fire OG",
        "strain_type": "Hybrid"
    },
    {
        "id": "407d9992-535c-41b5-9e66-c5d5c54bcf1f",
        "initial_consumption_type": "Flower",
        "value": "White Haze",
        "strain_type": "Indica"
    },
    {
        "id": "0d9695ee-5122-4b48-a46f-881d136db4fc",
        "initial_consumption_type": "Flower",
        "value": "White Ice",
        "strain_type": "Hybrid"
    },
    {
        "id": "a49e0cba-6fb6-4628-8c66-82ee256a6d94",
        "initial_consumption_type": "Flower",
        "value": "White Kush",
        "strain_type": "Indica"
    },
    {
        "id": "dc53eb15-b41c-4e9c-a3bb-7249c228f247",
        "initial_consumption_type": "Flower",
        "value": "White Queen",
        "strain_type": "Hybrid"
    },
    {
        "id": "56178fed-8e02-4037-9deb-820a2a0593ef",
        "initial_consumption_type": "Flower",
        "value": "White Rhino",
        "strain_type": "Hybrid"
    },
    {
        "id": "45966098-0284-4cf9-a1f4-3aa269ad1104",
        "initial_consumption_type": "Flower",
        "value": "White Russian",
        "strain_type": "Hybrid"
    },
    {
        "id": "8f156242-025c-4af2-998a-017685e95ab0",
        "initial_consumption_type": "Flower",
        "value": "White Shark",
        "strain_type": "Sativa"
    },
    {
        "id": "1df5d716-c387-4497-8650-89c249029a0e",
        "initial_consumption_type": "Flower",
        "value": "White Skunk",
        "strain_type": "Hybrid"
    },
    {
        "id": "2c1a05ef-f59f-4ec5-b9e5-e756f1485481",
        "initial_consumption_type": "Flower",
        "value": "White Widow",
        "strain_type": "Hybrid"
    },
    {
        "id": "5934db72-c3da-4c65-b6b8-028cecb9602c",
        "initial_consumption_type": "Flower",
        "value": "White Zombie",
        "strain_type": "Hybrid"
    },
    {
        "id": "2f236db7-0164-4150-8520-696ea1a66535",
        "initial_consumption_type": "Flower",
        "value": "Willie Nelson",
        "strain_type": "Sativa"
    },
    {
        "id": "f9d17f3f-72ab-422f-a620-7a2f3370b555",
        "initial_consumption_type": "Flower",
        "value": "Willie’s Wonder",
        "strain_type": "Hybrid"
    },
    {
        "id": "14da1a87-3efa-465d-95bd-91f98d1dad7e",
        "initial_consumption_type": "Flower",
        "value": "Willy’s Wonder",
        "strain_type": "Hybrid"
    },
    {
        "id": "ba62f6a5-381e-4172-9775-be531331b884",
        "initial_consumption_type": "Flower",
        "value": "Wonder Haze",
        "strain_type": "Hybrid"
    },
    {
        "id": "fcaaa3b6-4fba-46d6-be85-2b00a825fb00",
        "initial_consumption_type": "Flower",
        "value": "Wonder Woman",
        "strain_type": "Hybrid"
    },
    {
        "id": "b381d04b-c7cc-444b-9c21-63a5c402e11c",
        "initial_consumption_type": "Flower",
        "value": "Wonder Woman OG",
        "strain_type": "Indica"
    },
    {
        "id": "406bd6b0-fb63-459b-a11c-74bf575c5e4b",
        "initial_consumption_type": "Flower",
        "value": "Wonka’s Bubblicious",
        "strain_type": "Hybrid"
    },
    {
        "id": "85866c0f-9c9a-43a7-b11a-5dd911d0358b",
        "initial_consumption_type": "Flower",
        "value": "Woody Kush",
        "strain_type": "Indica"
    },
    {
        "id": "7768b1bb-514a-4ff7-91fb-d3dff5384883",
        "initial_consumption_type": "Flower",
        "value": "XJ-13",
        "strain_type": "Hybrid"
    },
    {
        "id": "8b4c2678-e46a-4577-9f84-3ab476494af8",
        "initial_consumption_type": "Flower",
        "value": "XXX 420",
        "strain_type": "Indica"
    },
    {
        "id": "401ec715-18a5-4bcf-a2b8-cd8bc6641632",
        "initial_consumption_type": "Flower",
        "value": "XXX OG",
        "strain_type": "Indica"
    },
    {
        "id": "121a9814-8afa-4a03-8b28-ff4ed9896948",
        "initial_consumption_type": "Flower",
        "value": "Yoda OG",
        "strain_type": "Indica"
    },
    {
        "id": "e9c4d58c-2943-4154-b6b6-f6933d7e863e",
        "initial_consumption_type": "Flower",
        "value": "Yuckleberry Wow",
        "strain_type": "Indica"
    },
    {
        "id": "506e943d-782b-4d22-96e0-571bcc732aa6",
        "initial_consumption_type": "Flower",
        "value": "Yumboldt",
        "strain_type": "Indica"
    },
    {
        "id": "364f86cb-d76d-459c-96aa-3fb833cd6067",
        "initial_consumption_type": "Flower",
        "value": "Zombie OG",
        "strain_type": "Indica"
    }
]